export const TimezonesV2 = [
  {
    timezone: 'Etc/GMT+12',
    offset: -12,
    text: '(-12:00) Etc/GMT+12',
    abbr: 'DST',
  },
  {
    timezone: 'Etc/GMT+11',
    offset: -11,
    text: '(-11:00) Etc/GMT+11',
    abbr: 'U',
  },
  {
    timezone: 'Pacific/Midway',
    offset: -11,
    text: '(-11:00) Pacific/Midway',
    abbr: 'U',
  },
  {
    timezone: 'Pacific/Niue',
    offset: -11,
    text: '(-11:00) Pacific/Niue',
    abbr: 'U',
  },
  {
    timezone: 'Pacific/Pago_Pago',
    offset: -11,
    text: '(-11:00) Pacific/Pago_Pago',
    abbr: 'U',
  },
  {
    timezone: 'Pacific/Samoa',
    offset: -11,
    text: '(-11:00) Pacific/Samoa',
    abbr: '',
  },
  {
    timezone: 'US/Samoa',
    offset: -11,
    text: '(-11:00) US/Samoa',
    abbr: '',
  },
  {
    timezone: 'Etc/GMT+10',
    offset: -10,
    text: '(-10:00) Etc/GMT+10',
    abbr: 'HST',
  },
  {
    timezone: 'Pacific/Honolulu',
    offset: -10,
    text: '(-10:00) Pacific/Honolulu',
    abbr: 'HST',
  },
  {
    timezone: 'Pacific/Johnston',
    offset: -10,
    text: '(-10:00) Pacific/Johnston',
    abbr: 'HST',
  },
  {
    timezone: 'Pacific/Rarotonga',
    offset: -10,
    text: '(-10:00) Pacific/Rarotonga',
    abbr: 'HST',
  },
  {
    timezone: 'Pacific/Tahiti',
    offset: -10,
    text: '(-10:00) Pacific/Tahiti',
    abbr: 'HST',
  },
  {
    timezone: 'US/Hawaii',
    offset: -10,
    text: '(-10:00) US/Hawaii',
    abbr: '',
  },
  {
    timezone: 'Pacific/Marquesas',
    offset: -9.5,
    text: '(-09:30) Pacific/Marquesas',
    abbr: '',
  },
  {
    timezone: 'America/Adak',
    offset: -9,
    text: '(-09:00) America/Adak',
    abbr: 'HST',
  },
  {
    timezone: 'America/Atka',
    offset: -9,
    text: '(-09:00) America/Atka',
    abbr: 'HST',
  },
  {
    timezone: 'Etc/GMT+9',
    offset: -9,
    text: '(-09:00) Etc/GMT+9',
    abbr: '',
  },
  {
    timezone: 'Pacific/Gambier',
    offset: -9,
    text: '(-09:00) Pacific/Gambier',
    abbr: '',
  },
  {
    timezone: 'US/Aleutian',
    offset: -9,
    text: '(-09:00) US/Aleutian',
    abbr: '',
  },
  {
    timezone: 'America/Anchorage',
    offset: -8,
    text: '(-08:00) America/Anchorage',
    abbr: 'AKDT',
  },
  {
    timezone: 'America/Juneau',
    offset: -8,
    text: '(-08:00) America/Juneau',
    abbr: 'AKDT',
  },
  {
    timezone: 'America/Metlakatla',
    offset: -8,
    text: '(-08:00) America/Metlakatla',
    abbr: 'AKDT',
  },
  {
    timezone: 'America/Nome',
    offset: -8,
    text: '(-08:00) America/Nome',
    abbr: 'AKDT',
  },
  {
    timezone: 'America/Sitka',
    offset: -8,
    text: '(-08:00) America/Sitka',
    abbr: 'AKDT',
  },
  {
    timezone: 'America/Yakutat',
    offset: -8,
    text: '(-08:00) America/Yakutat',
    abbr: 'AKDT',
  },
  {
    timezone: 'Etc/GMT+8',
    offset: -8,
    text: '(-08:00) Etc/GMT+8',
    abbr: '',
  },
  {
    timezone: 'Pacific/Pitcairn',
    offset: -8,
    text: '(-08:00) Pacific/Pitcairn',
    abbr: '',
  },
  {
    timezone: 'US/Alaska',
    offset: -8,
    text: '(-08:00) US/Alaska',
    abbr: '',
  },
  {
    timezone: 'America/Creston',
    offset: -7,
    text: '(-07:00) America/Creston',
    abbr: 'UMST',
  },
  {
    timezone: 'America/Dawson',
    offset: -7,
    text: '(-07:00) America/Dawson',
    abbr: 'UMST',
  },
  {
    timezone: 'America/Dawson_Creek',
    offset: -7,
    text: '(-07:00) America/Dawson_Creek',
    abbr: 'UMST',
  },
  {
    timezone: 'America/Ensenada',
    offset: -7,
    text: '(-07:00) America/Ensenada',
    abbr: 'PDT',
  },
  {
    timezone: 'America/Fort_Nelson',
    offset: -7,
    text: '(-07:00) America/Fort_Nelson',
    abbr: 'UMST',
  },
  {
    timezone: 'America/Hermosillo',
    offset: -7,
    text: '(-07:00) America/Hermosillo',
    abbr: 'UMST',
  },
  {
    timezone: 'America/Los_Angeles',
    offset: -7,
    text: '(-07:00) America/Los_Angeles',
    abbr: 'PDT',
  },
  {
    timezone: 'America/Phoenix',
    offset: -7,
    text: '(-07:00) America/Phoenix',
    abbr: 'UMST',
  },
  {
    timezone: 'America/Santa_Isabel',
    offset: -7,
    text: '(-07:00) America/Santa_Isabel',
    abbr: 'PDT',
  },
  {
    timezone: 'America/Tijuana',
    offset: -7,
    text: '(-07:00) America/Tijuana',
    abbr: 'PDT',
  },
  {
    timezone: 'America/Vancouver',
    offset: -7,
    text: '(-07:00) America/Vancouver',
    abbr: 'PDT',
  },
  {
    timezone: 'America/Whitehorse',
    offset: -7,
    text: '(-07:00) America/Whitehorse',
    abbr: 'UMST',
  },
  {
    timezone: 'Canada/Pacific',
    offset: -7,
    text: '(-07:00) Canada/Pacific',
    abbr: '',
  },
  {
    timezone: 'Canada/Yukon',
    offset: -7,
    text: '(-07:00) Canada/Yukon',
    abbr: '',
  },
  {
    timezone: 'Etc/GMT+7',
    offset: -7,
    text: '(-07:00) Etc/GMT+7',
    abbr: 'UMST',
  },
  {
    timezone: 'Mexico/BajaNorte',
    offset: -7,
    text: '(-07:00) Mexico/BajaNorte',
    abbr: '',
  },
  {
    timezone: 'PST8PDT',
    offset: -7,
    text: '(-07:00) PST8PDT',
    abbr: 'PST',
  },
  {
    timezone: 'US/Arizona',
    offset: -7,
    text: '(-07:00) US/Arizona',
    abbr: '',
  },
  {
    timezone: 'US/Pacific',
    offset: -7,
    text: '(-07:00) US/Pacific',
    abbr: '',
  },
  {
    timezone: 'US/Pacific-New',
    offset: -7,
    text: '(-07:00) US/Pacific-New',
    abbr: '',
  },
  {
    timezone: 'America/Belize',
    offset: -6,
    text: '(-06:00) America/Belize',
    abbr: 'CAST',
  },
  {
    timezone: 'America/Boise',
    offset: -6,
    text: '(-06:00) America/Boise',
    abbr: 'MDT',
  },
  {
    timezone: 'America/Cambridge_Bay',
    offset: -6,
    text: '(-06:00) America/Cambridge_Bay',
    abbr: 'MDT',
  },
  {
    timezone: 'America/Chihuahua',
    offset: -6,
    text: '(-06:00) America/Chihuahua',
    abbr: 'MDT',
  },
  {
    timezone: 'America/Costa_Rica',
    offset: -6,
    text: '(-06:00) America/Costa_Rica',
    abbr: 'CAST',
  },
  {
    timezone: 'America/Denver',
    offset: -6,
    text: '(-06:00) America/Denver',
    abbr: 'MDT',
  },
  {
    timezone: 'America/Edmonton',
    offset: -6,
    text: '(-06:00) America/Edmonton',
    abbr: 'MDT',
  },
  {
    timezone: 'America/El_Salvador',
    offset: -6,
    text: '(-06:00) America/El_Salvador',
    abbr: 'CAST',
  },
  {
    timezone: 'America/Guatemala',
    offset: -6,
    text: '(-06:00) America/Guatemala',
    abbr: 'CAST',
  },
  {
    timezone: 'America/Inuvik',
    offset: -6,
    text: '(-06:00) America/Inuvik',
    abbr: 'MDT',
  },
  {
    timezone: 'America/Managua',
    offset: -6,
    text: '(-06:00) America/Managua',
    abbr: 'CAST',
  },
  {
    timezone: 'America/Mazatlan',
    offset: -6,
    text: '(-06:00) America/Mazatlan',
    abbr: 'MDT',
  },
  {
    timezone: 'America/Ojinaga',
    offset: -6,
    text: '(-06:00) America/Ojinaga',
    abbr: 'MDT',
  },
  {
    timezone: 'America/Regina',
    offset: -6,
    text: '(-06:00) America/Regina',
    abbr: 'CCST',
  },
  {
    timezone: 'America/Shiprock',
    offset: -6,
    text: '(-06:00) America/Shiprock',
    abbr: 'MDT',
  },
  {
    timezone: 'America/Swift_Current',
    offset: -6,
    text: '(-06:00) America/Swift_Current',
    abbr: 'CCST',
  },
  {
    timezone: 'America/Tegucigalpa',
    offset: -6,
    text: '(-06:00) America/Tegucigalpa',
    abbr: 'CAST',
  },
  {
    timezone: 'America/Yellowknife',
    offset: -6,
    text: '(-06:00) America/Yellowknife',
    abbr: 'MDT',
  },
  {
    timezone: 'Canada/Mountain',
    offset: -6,
    text: '(-06:00) Canada/Mountain',
    abbr: '',
  },
  {
    timezone: 'Canada/Saskatchewan',
    offset: -6,
    text: '(-06:00) Canada/Saskatchewan',
    abbr: '',
  },
  {
    timezone: 'Etc/GMT+6',
    offset: -6,
    text: '(-06:00) Etc/GMT+6',
    abbr: 'CAST',
  },
  {
    timezone: 'MST7MDT',
    offset: -6,
    text: '(-06:00) MST7MDT',
    abbr: 'MDT',
  },
  {
    timezone: 'Mexico/BajaSur',
    offset: -6,
    text: '(-06:00) Mexico/BajaSur',
    abbr: '',
  },
  { timezone: 'Navajo', offset: -6, text: '(-06:00) Navajo', abbr: '' },
  {
    timezone: 'Pacific/Galapagos',
    offset: -6,
    text: '(-06:00) Pacific/Galapagos',
    abbr: 'CAST',
  },
  {
    timezone: 'US/Mountain',
    offset: -6,
    text: '(-06:00) US/Mountain',
    abbr: '',
  },
  {
    timezone: 'America/Atikokan',
    offset: -5,
    text: '(-05:00) America/Atikokan',
    abbr: 'EST',
  },
  {
    timezone: 'America/Bahia_Banderas',
    offset: -5,
    text: '(-05:00) America/Bahia_Banderas',
    abbr: 'CDT',
  },
  {
    timezone: 'America/Bogota',
    offset: -5,
    text: '(-05:00) America/Bogota',
    abbr: 'SPST',
  },
  {
    timezone: 'America/Cancun',
    offset: -5,
    text: '(-05:00) America/Cancun',
    abbr: 'CDT',
  },
  {
    timezone: 'America/Cayman',
    offset: -5,
    text: '(-05:00) America/Cayman',
    abbr: 'SPST',
  },
  {
    timezone: 'America/Chicago',
    offset: -5,
    text: '(-05:00) America/Chicago',
    abbr: 'CDT',
  },
  {
    timezone: 'America/Coral_Harbour',
    offset: -5,
    text: '(-05:00) America/Coral_Harbour',
    abbr: 'SPST',
  },
  {
    timezone: 'America/Eirunepe',
    offset: -5,
    text: '(-05:00) America/Eirunepe',
    abbr: 'SPST',
  },
  {
    timezone: 'America/Guayaquil',
    offset: -5,
    text: '(-05:00) America/Guayaquil',
    abbr: 'SPST',
  },
  {
    timezone: 'America/Indiana/Knox',
    offset: -5,
    text: '(-05:00) America/Indiana/Knox',
    abbr: 'CDT',
  },
  {
    timezone: 'America/Indiana/Tell_City',
    offset: -5,
    text: '(-05:00) America/Indiana/Tell_City',
    abbr: 'CDT',
  },
  {
    timezone: 'America/Jamaica',
    offset: -5,
    text: '(-05:00) America/Jamaica',
    abbr: 'SPST',
  },
  {
    timezone: 'America/Knox_IN',
    offset: -5,
    text: '(-05:00) America/Knox_IN',
    abbr: 'CDT',
  },
  {
    timezone: 'America/Lima',
    offset: -5,
    text: '(-05:00) America/Lima',
    abbr: 'SPST',
  },
  {
    timezone: 'America/Matamoros',
    offset: -5,
    text: '(-05:00) America/Matamoros',
    abbr: 'CDT',
  },
  {
    timezone: 'America/Menominee',
    offset: -5,
    text: '(-05:00) America/Menominee',
    abbr: 'CDT',
  },
  {
    timezone: 'America/Merida',
    offset: -5,
    text: '(-05:00) America/Merida',
    abbr: 'CDT',
  },
  {
    timezone: 'America/Mexico_City',
    offset: -5,
    text: '(-05:00) America/Mexico_City',
    abbr: 'CDT',
  },
  {
    timezone: 'America/Monterrey',
    offset: -5,
    text: '(-05:00) America/Monterrey',
    abbr: 'CDT',
  },
  {
    timezone: 'America/North_Dakota/Beulah',
    offset: -5,
    text: '(-05:00) America/North_Dakota/Beulah',
    abbr: 'CDT',
  },
  {
    timezone: 'America/North_Dakota/Center',
    offset: -5,
    text: '(-05:00) America/North_Dakota/Center',
    abbr: 'CDT',
  },
  {
    timezone: 'America/North_Dakota/New_Salem',
    offset: -5,
    text: '(-05:00) America/North_Dakota/New_Salem',
    abbr: 'CDT',
  },
  {
    timezone: 'America/Panama',
    offset: -5,
    text: '(-05:00) America/Panama',
    abbr: 'SPST',
  },
  {
    timezone: 'America/Porto_Acre',
    offset: -5,
    text: '(-05:00) America/Porto_Acre',
    abbr: 'ACT',
  },
  {
    timezone: 'America/Rainy_River',
    offset: -5,
    text: '(-05:00) America/Rainy_River',
    abbr: 'CDT',
  },
  {
    timezone: 'America/Rankin_Inlet',
    offset: -5,
    text: '(-05:00) America/Rankin_Inlet',
    abbr: 'CDT',
  },
  {
    timezone: 'America/Resolute',
    offset: -5,
    text: '(-05:00) America/Resolute',
    abbr: 'CDT',
  },
  {
    timezone: 'America/Rio_Branco',
    offset: -5,
    text: '(-05:00) America/Rio_Branco',
    abbr: 'SPST',
  },
  {
    timezone: 'America/Winnipeg',
    offset: -5,
    text: '(-05:00) America/Winnipeg',
    abbr: 'CDT',
  },
  {
    timezone: 'Brazil/Acre',
    offset: -5,
    text: '(-05:00) Brazil/Acre',
    abbr: '',
  },
  {
    timezone: 'CST6CDT',
    offset: -5,
    text: '(-05:00) CST6CDT',
    abbr: 'CDT',
  },
  {
    timezone: 'Canada/Central',
    offset: -5,
    text: '(-05:00) Canada/Central',
    abbr: '',
  },
  {
    timezone: 'Chile/EasterIsland',
    offset: -5,
    text: '(-05:00) Chile/EasterIsland',
    abbr: '',
  },
  {
    timezone: 'Etc/GMT+5',
    offset: -5,
    text: '(-05:00) Etc/GMT+5',
    abbr: 'SPST',
  },
  {
    timezone: 'Jamaica',
    offset: -5,
    text: '(-05:00) Jamaica',
    abbr: '',
  },
  {
    timezone: 'Mexico/General',
    offset: -5,
    text: '(-05:00) Mexico/General',
    abbr: '',
  },
  {
    timezone: 'Pacific/Easter',
    offset: -5,
    text: '(-05:00) Pacific/Easter',
    abbr: '',
  },
  {
    timezone: 'US/Central',
    offset: -5,
    text: '(-05:00) US/Central',
    abbr: 'CDT',
  },
  {
    timezone: 'US/Indiana-Starke',
    offset: -5,
    text: '(-05:00) US/Indiana-Starke',
    abbr: '',
  },
  {
    timezone: 'America/Anguilla',
    offset: -4,
    text: '(-04:00) America/Anguilla',
    abbr: 'SWST',
  },
  {
    timezone: 'America/Antigua',
    offset: -4,
    text: '(-04:00) America/Antigua',
    abbr: 'SWST',
  },
  {
    timezone: 'America/Aruba',
    offset: -4,
    text: '(-04:00) America/Aruba',
    abbr: 'SWST',
  },
  {
    timezone: 'America/Asuncion',
    offset: -4,
    text: '(-04:00) America/Asuncion',
    abbr: 'PYT',
  },
  {
    timezone: 'America/Barbados',
    offset: -4,
    text: '(-04:00) America/Barbados',
    abbr: 'SWST',
  },
  {
    timezone: 'America/Blanc-Sablon',
    offset: -4,
    text: '(-04:00) America/Blanc-Sablon',
    abbr: 'SWST',
  },
  {
    timezone: 'America/Boa_Vista',
    offset: -4,
    text: '(-04:00) America/Boa_Vista',
    abbr: 'SWST',
  },
  {
    timezone: 'America/Campo_Grande',
    offset: -4,
    text: '(-04:00) America/Campo_Grande',
    abbr: 'CBST',
  },
  {
    timezone: 'America/Caracas',
    offset: -4,
    text: '(-04:00) America/Caracas',
    abbr: 'VST',
  },
  {
    timezone: 'America/Cuiaba',
    offset: -4,
    text: '(-04:00) America/Cuiaba',
    abbr: 'CBST',
  },
  {
    timezone: 'America/Curacao',
    offset: -4,
    text: '(-04:00) America/Curacao',
    abbr: 'SWST',
  },
  {
    timezone: 'America/Detroit',
    offset: -4,
    text: '(-04:00) America/Detroit',
    abbr: 'EST',
  },
  {
    timezone: 'America/Dominica',
    offset: -4,
    text: '(-04:00) America/Dominica',
    abbr: 'SWST',
  },
  {
    timezone: 'America/Fort_Wayne',
    offset: -4,
    text: '(-04:00) America/Fort_Wayne',
    abbr: '',
  },
  {
    timezone: 'America/Grand_Turk',
    offset: -4,
    text: '(-04:00) America/Grand_Turk',
    abbr: 'SWST',
  },
  {
    timezone: 'America/Grenada',
    offset: -4,
    text: '(-04:00) America/Grenada',
    abbr: 'SWST',
  },
  {
    timezone: 'America/Guadeloupe',
    offset: -4,
    text: '(-04:00) America/Guadeloupe',
    abbr: 'SWST',
  },
  {
    timezone: 'America/Guyana',
    offset: -4,
    text: '(-04:00) America/Guyana',
    abbr: 'SWST',
  },
  {
    timezone: 'America/Havana',
    offset: -4,
    text: '(-04:00) America/Havana',
    abbr: 'EST',
  },
  {
    timezone: 'America/Indiana/Indianapolis',
    offset: -4,
    text: '(-04:00) America/Indiana/Indianapolis',
    abbr: 'EDT',
  },
  {
    timezone: 'America/Indiana/Marengo',
    offset: -4,
    text: '(-04:00) America/Indiana/Marengo',
    abbr: 'UEDT',
  },
  {
    timezone: 'America/Indiana/Petersburg',
    offset: -4,
    text: '(-04:00) America/Indiana/Petersburg',
    abbr: 'EST',
  },
  {
    timezone: 'America/Indiana/Vevay',
    offset: -4,
    text: '(-04:00) America/Indiana/Vevay',
    abbr: 'UEDT',
  },
  {
    timezone: 'America/Indiana/Vincennes',
    offset: -4,
    text: '(-04:00) America/Indiana/Vincennes',
    abbr: 'EST',
  },
  {
    timezone: 'America/Indiana/Winamac',
    offset: -4,
    text: '(-04:00) America/Indiana/Winamac',
    abbr: 'EST',
  },
  {
    timezone: 'America/Indianapolis',
    offset: -4,
    text: '(-04:00) America/Indianapolis',
    abbr: 'UEDT',
  },
  {
    timezone: 'America/Iqaluit',
    offset: -4,
    text: '(-04:00) America/Iqaluit',
    abbr: 'EST',
  },
  {
    timezone: 'America/Kentucky/Louisville',
    offset: -4,
    text: '(-04:00) America/Kentucky/Louisville',
    abbr: 'EDT',
  },
  {
    timezone: 'America/Kentucky/Monticello',
    offset: -4,
    text: '(-04:00) America/Kentucky/Monticello',
    abbr: 'EST',
  },
  {
    timezone: 'America/Kralendijk',
    offset: -4,
    text: '(-04:00) America/Kralendijk',
    abbr: 'SWST',
  },
  {
    timezone: 'America/La_Paz',
    offset: -4,
    text: '(-04:00) America/La_Paz',
    abbr: 'SWST',
  },
  {
    timezone: 'America/Louisville',
    offset: -4,
    text: '(-04:00) America/Louisville',
    abbr: 'EST',
  },
  {
    timezone: 'America/Lower_Princes',
    offset: -4,
    text: '(-04:00) America/Lower_Princes',
    abbr: 'SWST',
  },
  {
    timezone: 'America/Manaus',
    offset: -4,
    text: '(-04:00) America/Manaus',
    abbr: 'SWST',
  },
  {
    timezone: 'America/Marigot',
    offset: -4,
    text: '(-04:00) America/Marigot',
    abbr: 'SWST',
  },
  {
    timezone: 'America/Martinique',
    offset: -4,
    text: '(-04:00) America/Martinique',
    abbr: 'SWST',
  },
  {
    timezone: 'America/Montreal',
    offset: -4,
    text: '(-04:00) America/Montreal',
    abbr: 'EST',
  },
  {
    timezone: 'America/Montserrat',
    offset: -4,
    text: '(-04:00) America/Montserrat',
    abbr: 'SWST',
  },
  {
    timezone: 'America/Nassau',
    offset: -4,
    text: '(-04:00) America/Nassau',
    abbr: 'EST',
  },
  {
    timezone: 'America/New_York',
    offset: -4,
    text: '(-04:00) America/New_York',
    abbr: 'EST',
  },
  {
    timezone: 'America/Nipigon',
    offset: -4,
    text: '(-04:00) America/Nipigon',
    abbr: 'EST',
  },
  {
    timezone: 'America/Pangnirtung',
    offset: -4,
    text: '(-04:00) America/Pangnirtung',
    abbr: 'EST',
  },
  {
    timezone: 'America/Port-au-Prince',
    offset: -4,
    text: '(-04:00) America/Port-au-Prince',
    abbr: 'EST',
  },
  {
    timezone: 'America/Port_of_Spain',
    offset: -4,
    text: '(-04:00) America/Port_of_Spain',
    abbr: 'SWST',
  },
  {
    timezone: 'America/Porto_Velho',
    offset: -4,
    text: '(-04:00) America/Porto_Velho',
    abbr: 'SWST',
  },
  {
    timezone: 'America/Puerto_Rico',
    offset: -4,
    text: '(-04:00) America/Puerto_Rico',
    abbr: 'SWST',
  },
  {
    timezone: 'America/Santo_Domingo',
    offset: -4,
    text: '(-04:00) America/Santo_Domingo',
    abbr: 'SWST',
  },
  {
    timezone: 'America/St_Barthelemy',
    offset: -4,
    text: '(-04:00) America/St_Barthelemy',
    abbr: 'SWST',
  },
  {
    timezone: 'America/St_Kitts',
    offset: -4,
    text: '(-04:00) America/St_Kitts',
    abbr: 'SWST',
  },
  {
    timezone: 'America/St_Lucia',
    offset: -4,
    text: '(-04:00) America/St_Lucia',
    abbr: 'SWST',
  },
  {
    timezone: 'America/St_Thomas',
    offset: -4,
    text: '(-04:00) America/St_Thomas',
    abbr: 'SWST',
  },
  {
    timezone: 'America/St_Vincent',
    offset: -4,
    text: '(-04:00) America/St_Vincent',
    abbr: 'SWST',
  },
  {
    timezone: 'America/Thunder_Bay',
    offset: -4,
    text: '(-04:00) America/Thunder_Bay',
    abbr: 'EST',
  },
  {
    timezone: 'America/Toronto',
    offset: -4,
    text: '(-04:00) America/Toronto',
    abbr: 'EST',
  },
  {
    timezone: 'America/Tortola',
    offset: -4,
    text: '(-04:00) America/Tortola',
    abbr: 'SWST',
  },
  {
    timezone: 'America/Virgin',
    offset: -4,
    text: '(-04:00) America/Virgin',
    abbr: 'MDT',
  },
  {
    timezone: 'Brazil/West',
    offset: -4,
    text: '(-04:00) Brazil/West',
    abbr: '',
  },
  {
    timezone: 'Canada/Eastern',
    offset: -4,
    text: '(-04:00) Canada/Eastern',
    abbr: '',
  },
  { timezone: 'Cuba', offset: -4, text: '(-04:00) Cuba', abbr: '' },
  {
    timezone: 'EST5EDT',
    offset: -4,
    text: '(-04:00) EST5EDT',
    abbr: '',
  },
  {
    timezone: 'Etc/GMT+4',
    offset: -4,
    text: '(-04:00) Etc/GMT+4',
    abbr: 'SWST',
  },
  {
    timezone: 'US/East-Indiana',
    offset: -4,
    text: '(-04:00) US/East-Indiana',
    abbr: '',
  },
  {
    timezone: 'US/Eastern',
    offset: -4,
    text: '(-04:00) US/Eastern',
    abbr: '',
  },
  {
    timezone: 'US/Michigan',
    offset: -4,
    text: '(-04:00) US/Michigan',
    abbr: '',
  },
  {
    timezone: 'America/Araguaina',
    offset: -3,
    text: '(-03:00) America/Araguaina',
    abbr: 'SEST',
  },
  {
    timezone: 'America/Argentina/Buenos_Aires',
    offset: -3,
    text: '(-03:00) America/Argentina/Buenos_Aires',
    abbr: 'AST',
  },
  {
    timezone: 'America/Argentina/Catamarca',
    offset: -3,
    text: '(-03:00) America/Argentina/Catamarca',
    abbr: 'AST',
  },
  {
    timezone: 'America/Argentina/ComodRivadavia',
    offset: -3,
    text: '(-03:00) America/Argentina/ComodRivadavia',
    abbr: 'AST',
  },
  {
    timezone: 'America/Argentina/Cordoba',
    offset: -3,
    text: '(-03:00) America/Argentina/Cordoba',
    abbr: 'AST',
  },
  {
    timezone: 'America/Argentina/Jujuy',
    offset: -3,
    text: '(-03:00) America/Argentina/Jujuy',
    abbr: '',
  },
  {
    timezone: 'America/Argentina/La_Rioja',
    offset: -3,
    text: '(-03:00) America/Argentina/La_Rioja',
    abbr: 'AST',
  },
  {
    timezone: 'America/Argentina/Mendoza',
    offset: -3,
    text: '(-03:00) America/Argentina/Mendoza',
    abbr: 'AST',
  },
  {
    timezone: 'America/Argentina/Rio_Gallegos',
    offset: -3,
    text: '(-03:00) America/Argentina/Rio_Gallegos',
    abbr: 'AST',
  },
  {
    timezone: 'America/Argentina/Salta',
    offset: -3,
    text: '(-03:00) America/Argentina/Salta',
    abbr: 'AST',
  },
  {
    timezone: 'America/Argentina/San_Juan',
    offset: -3,
    text: '(-03:00) America/Argentina/San_Juan',
    abbr: 'AST',
  },
  {
    timezone: 'America/Argentina/San_Luis',
    offset: -3,
    text: '(-03:00) America/Argentina/San_Luis',
    abbr: 'AST',
  },
  {
    timezone: 'America/Argentina/Tucuman',
    offset: -3,
    text: '(-03:00) America/Argentina/Tucuman',
    abbr: 'AST',
  },
  {
    timezone: 'America/Argentina/Ushuaia',
    offset: -3,
    text: '(-03:00) America/Argentina/Ushuaia',
    abbr: 'AST',
  },
  {
    timezone: 'America/Bahia',
    offset: -3,
    text: '(-03:00) America/Bahia',
    abbr: 'BST',
  },
  {
    timezone: 'America/Belem',
    offset: -3,
    text: '(-03:00) America/Belem',
    abbr: 'SEST',
  },
  {
    timezone: 'America/Buenos_Aires',
    offset: -3,
    text: '(-03:00) America/Buenos_Aires',
    abbr: 'AST',
  },
  {
    timezone: 'America/Catamarca',
    offset: -3,
    text: '(-03:00) America/Catamarca',
    abbr: 'AST',
  },
  {
    timezone: 'America/Cayenne',
    offset: -3,
    text: '(-03:00) America/Cayenne',
    abbr: 'SEST',
  },
  {
    timezone: 'America/Cordoba',
    offset: -3,
    text: '(-03:00) America/Cordoba',
    abbr: 'AST',
  },
  {
    timezone: 'America/Fortaleza',
    offset: -3,
    text: '(-03:00) America/Fortaleza',
    abbr: 'SEST',
  },
  {
    timezone: 'America/Glace_Bay',
    offset: -3,
    text: '(-03:00) America/Glace_Bay',
    abbr: 'ADT',
  },
  {
    timezone: 'America/Goose_Bay',
    offset: -3,
    text: '(-03:00) America/Goose_Bay',
    abbr: 'ADT',
  },
  {
    timezone: 'America/Halifax',
    offset: -3,
    text: '(-03:00) America/Halifax',
    abbr: 'ADT',
  },
  {
    timezone: 'America/Jujuy',
    offset: -3,
    text: '(-03:00) America/Jujuy',
    abbr: 'AST',
  },
  {
    timezone: 'America/Maceio',
    offset: -3,
    text: '(-03:00) America/Maceio',
    abbr: 'SEST',
  },
  {
    timezone: 'America/Mendoza',
    offset: -3,
    text: '(-03:00) America/Mendoza',
    abbr: 'AST',
  },
  {
    timezone: 'America/Moncton',
    offset: -3,
    text: '(-03:00) America/Moncton',
    abbr: 'ADT',
  },
  {
    timezone: 'America/Montevideo',
    offset: -3,
    text: '(-03:00) America/Montevideo',
    abbr: 'MST',
  },
  {
    timezone: 'America/Paramaribo',
    offset: -3,
    text: '(-03:00) America/Paramaribo',
    abbr: 'SEST',
  },
  {
    timezone: 'America/Punta_Arenas',
    offset: -3,
    text: '(-03:00) America/Punta_Arenas',
    abbr: 'CLST',
  },
  {
    timezone: 'America/Recife',
    offset: -3,
    text: '(-03:00) America/Recife',
    abbr: 'SEST',
  },
  {
    timezone: 'America/Rosario',
    offset: -3,
    text: '(-03:00) America/Rosario',
    abbr: 'AST',
  },
  {
    timezone: 'America/Santarem',
    offset: -3,
    text: '(-03:00) America/Santarem',
    abbr: 'SEST',
  },
  {
    timezone: 'America/Santiago',
    offset: -3,
    text: '(-03:00) America/Santiago',
    abbr: 'PSST',
  },
  {
    timezone: 'America/Sao_Paulo',
    offset: -3,
    text: '(-03:00) America/Sao_Paulo',
    abbr: 'ESAST',
  },
  {
    timezone: 'America/Thule',
    offset: -3,
    text: '(-03:00) America/Thule',
    abbr: 'ADT',
  },
  {
    timezone: 'Antarctica/Palmer',
    offset: -3,
    text: '(-03:00) Antarctica/Palmer',
    abbr: 'PSST',
  },
  {
    timezone: 'Antarctica/Rothera',
    offset: -3,
    text: '(-03:00) Antarctica/Rothera',
    abbr: 'SEST',
  },
  {
    timezone: 'Atlantic/Bermuda',
    offset: -3,
    text: '(-03:00) Atlantic/Bermuda',
    abbr: 'ADT',
  },
  {
    timezone: 'Atlantic/Stanley',
    offset: -3,
    text: '(-03:00) Atlantic/Stanley',
    abbr: 'SEST',
  },
  {
    timezone: 'Brazil/East',
    offset: -3,
    text: '(-03:00) Brazil/East',
    abbr: '',
  },
  {
    timezone: 'Canada/Atlantic',
    offset: -3,
    text: '(-03:00) Canada/Atlantic',
    abbr: '',
  },
  {
    timezone: 'Chile/Continental',
    offset: -3,
    text: '(-03:00) Chile/Continental',
    abbr: '',
  },
  {
    timezone: 'Etc/GMT+3',
    offset: -3,
    text: '(-03:00) Etc/GMT+3',
    abbr: 'SEST',
  },
  {
    timezone: 'America/St_Johns',
    offset: -2.5,
    text: '(-02:30) America/St_Johns',
    abbr: 'NDT',
  },
  {
    timezone: 'Canada/Newfoundland',
    offset: -2.5,
    text: '(-02:30) Canada/Newfoundland',
    abbr: '',
  },
  {
    timezone: 'America/Godthab',
    offset: -2,
    text: '(-02:00) America/Godthab',
    abbr: 'GDT',
  },
  {
    timezone: 'America/Miquelon',
    offset: -2,
    text: '(-02:00) America/Miquelon',
    abbr: 'U',
  },
  {
    timezone: 'America/Noronha',
    offset: -2,
    text: '(-02:00) America/Noronha',
    abbr: 'U',
  },
  {
    timezone: 'Atlantic/South_Georgia',
    offset: -2,
    text: '(-02:00) Atlantic/South_Georgia',
    abbr: 'U',
  },
  {
    timezone: 'Brazil/DeNoronha',
    offset: -2,
    text: '(-02:00) Brazil/DeNoronha',
    abbr: '',
  },
  {
    timezone: 'Etc/GMT+2',
    offset: -2,
    text: '(-02:00) Etc/GMT+2',
    abbr: 'U',
  },
  {
    timezone: 'Atlantic/Cape_Verde',
    offset: -1,
    text: '(-01:00) Atlantic/Cape_Verde',
    abbr: 'CVST',
  },
  {
    timezone: 'Etc/GMT+1',
    offset: -1,
    text: '(-01:00) Etc/GMT+1',
    abbr: 'CVST',
  },
  {
    timezone: 'Africa/Algiers',
    offset: 1,
    text: '(+01:00) Africa/Algiers',
    abbr: 'WCAST',
  },
  {
    timezone: 'Africa/Bangui',
    offset: 1,
    text: '(+01:00) Africa/Bangui',
    abbr: 'WCAST',
  },
  {
    timezone: 'Africa/Brazzaville',
    offset: 1,
    text: '(+01:00) Africa/Brazzaville',
    abbr: 'WCAST',
  },
  {
    timezone: 'Africa/Casablanca',
    offset: 1,
    text: '(+01:00) Africa/Casablanca',
    abbr: 'MDT',
  },
  {
    timezone: 'Africa/Douala',
    offset: 1,
    text: '(+01:00) Africa/Douala',
    abbr: 'WCAST',
  },
  {
    timezone: 'Africa/El_Aaiun',
    offset: 1,
    text: '(+01:00) Africa/El_Aaiun',
    abbr: 'MDT',
  },
  {
    timezone: 'Africa/Kinshasa',
    offset: 1,
    text: '(+01:00) Africa/Kinshasa',
    abbr: 'WCAST',
  },
  {
    timezone: 'Africa/Lagos',
    offset: 1,
    text: '(+01:00) Africa/Lagos',
    abbr: 'WCAST',
  },
  {
    timezone: 'Africa/Libreville',
    offset: 1,
    text: '(+01:00) Africa/Libreville',
    abbr: 'WCAST',
  },
  {
    timezone: 'Africa/Luanda',
    offset: 1,
    text: '(+01:00) Africa/Luanda',
    abbr: 'WCAST',
  },
  {
    timezone: 'Africa/Malabo',
    offset: 1,
    text: '(+01:00) Africa/Malabo',
    abbr: 'WCAST',
  },
  {
    timezone: 'Africa/Ndjamena',
    offset: 1,
    text: '(+01:00) Africa/Ndjamena',
    abbr: 'WCAST',
  },
  {
    timezone: 'Africa/Niamey',
    offset: 1,
    text: '(+01:00) Africa/Niamey',
    abbr: 'WCAST',
  },
  {
    timezone: 'Africa/Porto-Novo',
    offset: 1,
    text: '(+01:00) Africa/Porto-Novo',
    abbr: 'WCAST',
  },
  {
    timezone: 'Africa/Tunis',
    offset: 1,
    text: '(+01:00) Africa/Tunis',
    abbr: 'WCAST',
  },
  {
    timezone: 'Atlantic/Canary',
    offset: 1,
    text: '(+01:00) Atlantic/Canary',
    abbr: 'GDT',
  },
  {
    timezone: 'Atlantic/Faeroe',
    offset: 1,
    text: '(+01:00) Atlantic/Faeroe',
    abbr: 'GDT',
  },
  {
    timezone: 'Atlantic/Faroe',
    offset: 1,
    text: '(+01:00) Atlantic/Faroe',
    abbr: '',
  },
  {
    timezone: 'Atlantic/Madeira',
    offset: 1,
    text: '(+01:00) Atlantic/Madeira',
    abbr: 'GDT',
  },
  { timezone: 'Eire', offset: 1, text: '(+01:00) Eire', abbr: '' },
  {
    timezone: 'Etc/GMT-1',
    offset: 1,
    text: '(+01:00) Etc/GMT-1',
    abbr: 'WCAST',
  },
  {
    timezone: 'Europe/Belfast',
    offset: 1,
    text: '(+01:00) Europe/Belfast',
    abbr: '',
  },
  {
    timezone: 'Europe/Dublin',
    offset: 1,
    text: '(+01:00) Europe/Dublin',
    abbr: 'GDT',
  },
  {
    timezone: 'Europe/Guernsey',
    offset: 1,
    text: '(+01:00) Europe/Guernsey',
    abbr: 'GMT',
  },
  {
    timezone: 'Europe/Isle_of_Man',
    offset: 1,
    text: '(+01:00) Europe/Isle_of_Man',
    abbr: 'GMT',
  },
  {
    timezone: 'Europe/Jersey',
    offset: 1,
    text: '(+01:00) Europe/Jersey',
    abbr: 'GMT',
  },
  {
    timezone: 'Europe/Lisbon',
    offset: 1,
    text: '(+01:00) Europe/Lisbon',
    abbr: 'GDT',
  },
  {
    timezone: 'Europe/London',
    offset: 1,
    text: '(+01:00) Europe/London',
    abbr: 'GMT',
  },
  { timezone: 'GB', offset: 1, text: '(+01:00) GB', abbr: '' },
  {
    timezone: 'GB-Eire',
    offset: 1,
    text: '(+01:00) GB-Eire',
    abbr: '',
  },
  {
    timezone: 'Portugal',
    offset: 1,
    text: '(+01:00) Portugal',
    abbr: '',
  },
  { timezone: 'WET', offset: 1, text: '(+01:00) WET', abbr: '' },
  {
    timezone: 'Africa/Blantyre',
    offset: 2,
    text: '(+02:00) Africa/Blantyre',
    abbr: 'SAST',
  },
  {
    timezone: 'Africa/Bujumbura',
    offset: 2,
    text: '(+02:00) Africa/Bujumbura',
    abbr: 'SAST',
  },
  {
    timezone: 'Africa/Cairo',
    offset: 2,
    text: '(+02:00) Africa/Cairo',
    abbr: 'EST',
  },
  {
    timezone: 'Africa/Ceuta',
    offset: 2,
    text: '(+02:00) Africa/Ceuta',
    abbr: 'RDT',
  },
  {
    timezone: 'Africa/Gaborone',
    offset: 2,
    text: '(+02:00) Africa/Gaborone',
    abbr: 'SAST',
  },
  {
    timezone: 'Africa/Harare',
    offset: 2,
    text: '(+02:00) Africa/Harare',
    abbr: 'SAST',
  },
  {
    timezone: 'Africa/Johannesburg',
    offset: 2,
    text: '(+02:00) Africa/Johannesburg',
    abbr: 'SAST',
  },
  {
    timezone: 'Africa/Juba',
    offset: 2,
    text: '(+02:00) Africa/Juba',
    abbr: 'EAST',
  },
  {
    timezone: 'Africa/Khartoum',
    offset: 2,
    text: '(+02:00) Africa/Khartoum',
    abbr: 'EAST',
  },
  {
    timezone: 'Africa/Kigali',
    offset: 2,
    text: '(+02:00) Africa/Kigali',
    abbr: 'SAST',
  },
  {
    timezone: 'Africa/Lubumbashi',
    offset: 2,
    text: '(+02:00) Africa/Lubumbashi',
    abbr: 'SAST',
  },
  {
    timezone: 'Africa/Lusaka',
    offset: 2,
    text: '(+02:00) Africa/Lusaka',
    abbr: 'SAST',
  },
  {
    timezone: 'Africa/Maputo',
    offset: 2,
    text: '(+02:00) Africa/Maputo',
    abbr: 'SAST',
  },
  {
    timezone: 'Africa/Maseru',
    offset: 2,
    text: '(+02:00) Africa/Maseru',
    abbr: 'SAST',
  },
  {
    timezone: 'Africa/Mbabane',
    offset: 2,
    text: '(+02:00) Africa/Mbabane',
    abbr: 'SAST',
  },
  {
    timezone: 'Africa/Tripoli',
    offset: 2,
    text: '(+02:00) Africa/Tripoli',
    abbr: 'LST',
  },
  {
    timezone: 'Africa/Windhoek',
    offset: 2,
    text: '(+02:00) Africa/Windhoek',
    abbr: 'NST',
  },
  {
    timezone: 'Antarctica/Troll',
    offset: 2,
    text: '(+02:00) Antarctica/Troll',
    abbr: '',
  },
  {
    timezone: 'Arctic/Longyearbyen',
    offset: 2,
    text: '(+02:00) Arctic/Longyearbyen',
    abbr: 'WEDT',
  },
  {
    timezone: 'Atlantic/Jan_Mayen',
    offset: 2,
    text: '(+02:00) Atlantic/Jan_Mayen',
    abbr: '',
  },
  { timezone: 'CET', offset: 2, text: '(+02:00) CET', abbr: '' },
  { timezone: 'Egypt', offset: 2, text: '(+02:00) Egypt', abbr: '' },
  {
    timezone: 'Etc/GMT-2',
    offset: 2,
    text: '(+02:00) Etc/GMT-2',
    abbr: 'SAST',
  },
  {
    timezone: 'Europe/Amsterdam',
    offset: 2,
    text: '(+02:00) Europe/Amsterdam',
    abbr: 'WEDT',
  },
  {
    timezone: 'Europe/Andorra',
    offset: 2,
    text: '(+02:00) Europe/Andorra',
    abbr: 'WEDT',
  },
  {
    timezone: 'Europe/Belgrade',
    offset: 2,
    text: '(+02:00) Europe/Belgrade',
    abbr: 'CEDT',
  },
  {
    timezone: 'Europe/Berlin',
    offset: 2,
    text: '(+02:00) Europe/Berlin',
    abbr: 'WEDT',
  },
  {
    timezone: 'Europe/Bratislava',
    offset: 2,
    text: '(+02:00) Europe/Bratislava',
    abbr: 'CEDT',
  },
  {
    timezone: 'Europe/Brussels',
    offset: 2,
    text: '(+02:00) Europe/Brussels',
    abbr: 'RDT',
  },
  {
    timezone: 'Europe/Budapest',
    offset: 2,
    text: '(+02:00) Europe/Budapest',
    abbr: 'CEDT',
  },
  {
    timezone: 'Europe/Busingen',
    offset: 2,
    text: '(+02:00) Europe/Busingen',
    abbr: 'WEDT',
  },
  {
    timezone: 'Europe/Copenhagen',
    offset: 2,
    text: '(+02:00) Europe/Copenhagen',
    abbr: 'RDT',
  },
  {
    timezone: 'Europe/Gibraltar',
    offset: 2,
    text: '(+02:00) Europe/Gibraltar',
    abbr: 'WEDT',
  },
  {
    timezone: 'Europe/Kaliningrad',
    offset: 2,
    text: '(+02:00) Europe/Kaliningrad',
    abbr: 'KST',
  },
  {
    timezone: 'Europe/Ljubljana',
    offset: 2,
    text: '(+02:00) Europe/Ljubljana',
    abbr: 'CEDT',
  },
  {
    timezone: 'Europe/Luxembourg',
    offset: 2,
    text: '(+02:00) Europe/Luxembourg',
    abbr: 'WEDT',
  },
  {
    timezone: 'Europe/Madrid',
    offset: 2,
    text: '(+02:00) Europe/Madrid',
    abbr: 'RDT',
  },
  {
    timezone: 'Europe/Malta',
    offset: 2,
    text: '(+02:00) Europe/Malta',
    abbr: 'WEDT',
  },
  {
    timezone: 'Europe/Monaco',
    offset: 2,
    text: '(+02:00) Europe/Monaco',
    abbr: 'WEDT',
  },
  {
    timezone: 'Europe/Oslo',
    offset: 2,
    text: '(+02:00) Europe/Oslo',
    abbr: 'WEDT',
  },
  {
    timezone: 'Europe/Paris',
    offset: 2,
    text: '(+02:00) Europe/Paris',
    abbr: 'RDT',
  },
  {
    timezone: 'Europe/Podgorica',
    offset: 2,
    text: '(+02:00) Europe/Podgorica',
    abbr: 'CEDT',
  },
  {
    timezone: 'Europe/Prague',
    offset: 2,
    text: '(+02:00) Europe/Prague',
    abbr: 'CEDT',
  },
  {
    timezone: 'Europe/Rome',
    offset: 2,
    text: '(+02:00) Europe/Rome',
    abbr: 'WEDT',
  },
  {
    timezone: 'Europe/San_Marino',
    offset: 2,
    text: '(+02:00) Europe/San_Marino',
    abbr: 'WEDT',
  },
  {
    timezone: 'Europe/Sarajevo',
    offset: 2,
    text: '(+02:00) Europe/Sarajevo',
    abbr: 'CEDT',
  },
  {
    timezone: 'Europe/Skopje',
    offset: 2,
    text: '(+02:00) Europe/Skopje',
    abbr: 'CEDT',
  },
  {
    timezone: 'Europe/Stockholm',
    offset: 2,
    text: '(+02:00) Europe/Stockholm',
    abbr: 'WEDT',
  },
  {
    timezone: 'Europe/Tirane',
    offset: 2,
    text: '(+02:00) Europe/Tirane',
    abbr: 'CEDT',
  },
  {
    timezone: 'Europe/Vaduz',
    offset: 2,
    text: '(+02:00) Europe/Vaduz',
    abbr: 'WEDT',
  },
  {
    timezone: 'Europe/Vatican',
    offset: 2,
    text: '(+02:00) Europe/Vatican',
    abbr: 'WEDT',
  },
  {
    timezone: 'Europe/Vienna',
    offset: 2,
    text: '(+02:00) Europe/Vienna',
    abbr: 'WEDT',
  },
  {
    timezone: 'Europe/Warsaw',
    offset: 2,
    text: '(+02:00) Europe/Warsaw',
    abbr: 'CEDT',
  },
  {
    timezone: 'Europe/Zagreb',
    offset: 2,
    text: '(+02:00) Europe/Zagreb',
    abbr: 'CEDT',
  },
  {
    timezone: 'Europe/Zurich',
    offset: 2,
    text: '(+02:00) Europe/Zurich',
    abbr: 'WEDT',
  },
  { timezone: 'Libya', offset: 2, text: '(+02:00) Libya', abbr: '' },
  { timezone: 'MET', offset: 2, text: '(+02:00) MET', abbr: '' },
  { timezone: 'Poland', offset: 2, text: '(+02:00) Poland', abbr: '' },
  {
    timezone: 'Africa/Addis_Ababa',
    offset: 3,
    text: '(+03:00) Africa/Addis_Ababa',
    abbr: 'EAST',
  },
  {
    timezone: 'Africa/Asmara',
    offset: 3,
    text: '(+03:00) Africa/Asmara',
    abbr: '',
  },
  {
    timezone: 'Africa/Asmera',
    offset: 3,
    text: '(+03:00) Africa/Asmera',
    abbr: 'EAST',
  },
  {
    timezone: 'Africa/Dar_es_Salaam',
    offset: 3,
    text: '(+03:00) Africa/Dar_es_Salaam',
    abbr: 'EAST',
  },
  {
    timezone: 'Africa/Djibouti',
    offset: 3,
    text: '(+03:00) Africa/Djibouti',
    abbr: 'EAST',
  },
  {
    timezone: 'Africa/Kampala',
    offset: 3,
    text: '(+03:00) Africa/Kampala',
    abbr: 'EAST',
  },
  {
    timezone: 'Africa/Mogadishu',
    offset: 3,
    text: '(+03:00) Africa/Mogadishu',
    abbr: 'EAST',
  },
  {
    timezone: 'Africa/Nairobi',
    offset: 3,
    text: '(+03:00) Africa/Nairobi',
    abbr: 'EAST',
  },
  {
    timezone: 'Antarctica/Syowa',
    offset: 3,
    text: '(+03:00) Antarctica/Syowa',
    abbr: 'EAST',
  },
  {
    timezone: 'Asia/Aden',
    offset: 3,
    text: '(+03:00) Asia/Aden',
    abbr: 'AST',
  },
  {
    timezone: 'Asia/Amman',
    offset: 3,
    text: '(+03:00) Asia/Amman',
    abbr: 'JST',
  },
  {
    timezone: 'Asia/Baghdad',
    offset: 3,
    text: '(+03:00) Asia/Baghdad',
    abbr: 'AST',
  },
  {
    timezone: 'Asia/Bahrain',
    offset: 3,
    text: '(+03:00) Asia/Bahrain',
    abbr: 'AST',
  },
  {
    timezone: 'Asia/Beirut',
    offset: 3,
    text: '(+03:00) Asia/Beirut',
    abbr: 'MEDT',
  },
  {
    timezone: 'Asia/Damascus',
    offset: 3,
    text: '(+03:00) Asia/Damascus',
    abbr: 'SDT',
  },
  {
    timezone: 'Asia/Famagusta',
    offset: 3,
    text: '(+03:00) Asia/Famagusta',
    abbr: 'EEST',
  },
  {
    timezone: 'Asia/Gaza',
    offset: 3,
    text: '(+03:00) Asia/Gaza',
    abbr: 'EEST',
  },
  {
    timezone: 'Asia/Hebron',
    offset: 3,
    text: '(+03:00) Asia/Hebron',
    abbr: 'EEST',
  },
  {
    timezone: 'Asia/Istanbul',
    offset: 3,
    text: '(+03:00) Asia/Istanbul',
    abbr: 'TDT',
  },
  {
    timezone: 'Asia/Jerusalem',
    offset: 3,
    text: '(+03:00) Asia/Jerusalem',
    abbr: 'JDT',
  },
  {
    timezone: 'Asia/Kuwait',
    offset: 3,
    text: '(+03:00) Asia/Kuwait',
    abbr: 'AST',
  },
  {
    timezone: 'Asia/Nicosia',
    offset: 3,
    text: '(+03:00) Asia/Nicosia',
    abbr: 'GDT',
  },
  {
    timezone: 'Asia/Qatar',
    offset: 3,
    text: '(+03:00) Asia/Qatar',
    abbr: 'AST',
  },
  {
    timezone: 'Asia/Riyadh',
    offset: 3,
    text: '(+03:00) Asia/Riyadh',
    abbr: 'AST',
  },
  {
    timezone: 'Asia/Tel_Aviv',
    offset: 3,
    text: '(+03:00) Asia/Tel_Aviv',
    abbr: 'IDT',
  },
  { timezone: 'EET', offset: 3, text: '(+03:00) EET', abbr: '' },
  {
    timezone: 'Etc/GMT-3',
    offset: 3,
    text: '(+03:00) Etc/GMT-3',
    abbr: 'EAST',
  },
  {
    timezone: 'Europe/Athens',
    offset: 3,
    text: '(+03:00) Europe/Athens',
    abbr: 'GDT',
  },
  {
    timezone: 'Europe/Bucharest',
    offset: 3,
    text: '(+03:00) Europe/Bucharest',
    abbr: 'GDT',
  },
  {
    timezone: 'Europe/Chisinau',
    offset: 3,
    text: '(+03:00) Europe/Chisinau',
    abbr: 'GDT',
  },
  {
    timezone: 'Europe/Helsinki',
    offset: 3,
    text: '(+03:00) Europe/Helsinki',
    abbr: 'EEDT',
  },
  {
    timezone: 'Europe/Istanbul',
    offset: 3,
    text: '(+03:00) Europe/Istanbul',
    abbr: 'TDT',
  },
  {
    timezone: 'Europe/Kiev',
    offset: 3,
    text: '(+03:00) Europe/Kiev',
    abbr: 'EEDT',
  },
  {
    timezone: 'Europe/Kirov',
    offset: 3,
    text: '(+03:00) Europe/Kirov',
    abbr: 'MSK',
  },
  {
    timezone: 'Europe/Mariehamn',
    offset: 3,
    text: '(+03:00) Europe/Mariehamn',
    abbr: 'EEDT',
  },
  {
    timezone: 'Europe/Minsk',
    offset: 3,
    text: '(+03:00) Europe/Minsk',
    abbr: 'MSK',
  },
  {
    timezone: 'Europe/Moscow',
    offset: 3,
    text: '(+03:00) Europe/Moscow',
    abbr: 'MSK',
  },
  {
    timezone: 'Europe/Nicosia',
    offset: 3,
    text: '(+03:00) Europe/Nicosia',
    abbr: 'EEDT',
  },
  {
    timezone: 'Europe/Riga',
    offset: 3,
    text: '(+03:00) Europe/Riga',
    abbr: 'EEDT',
  },
  {
    timezone: 'Europe/Simferopol',
    offset: 3,
    text: '(+03:00) Europe/Simferopol',
    abbr: 'MSK',
  },
  {
    timezone: 'Europe/Sofia',
    offset: 3,
    text: '(+03:00) Europe/Sofia',
    abbr: 'EEDT',
  },
  {
    timezone: 'Europe/Tallinn',
    offset: 3,
    text: '(+03:00) Europe/Tallinn',
    abbr: 'EEDT',
  },
  {
    timezone: 'Europe/Tiraspol',
    offset: 3,
    text: '(+03:00) Europe/Tiraspol',
    abbr: '',
  },
  {
    timezone: 'Europe/Uzhgorod',
    offset: 3,
    text: '(+03:00) Europe/Uzhgorod',
    abbr: 'EEDT',
  },
  {
    timezone: 'Europe/Vilnius',
    offset: 3,
    text: '(+03:00) Europe/Vilnius',
    abbr: 'EEDT',
  },
  {
    timezone: 'Europe/Volgograd',
    offset: 3,
    text: '(+03:00) Europe/Volgograd',
    abbr: 'MSK',
  },
  {
    timezone: 'Europe/Zaporozhye',
    offset: 3,
    text: '(+03:00) Europe/Zaporozhye',
    abbr: 'EEDT',
  },
  {
    timezone: 'Indian/Antananarivo',
    offset: 3,
    text: '(+03:00) Indian/Antananarivo',
    abbr: 'EAST',
  },
  {
    timezone: 'Indian/Comoro',
    offset: 3,
    text: '(+03:00) Indian/Comoro',
    abbr: 'EAST',
  },
  {
    timezone: 'Indian/Mayotte',
    offset: 3,
    text: '(+03:00) Indian/Mayotte',
    abbr: 'EAST',
  },
  { timezone: 'Israel', offset: 3, text: '(+03:00) Israel', abbr: '' },
  { timezone: 'Turkey', offset: 3, text: '(+03:00) Turkey', abbr: '' },
  { timezone: 'W-SU', offset: 3, text: '(+03:00) W-SU', abbr: '' },
  {
    timezone: 'Asia/Baku',
    offset: 4,
    text: '(+04:00) Asia/Baku',
    abbr: 'ADT',
  },
  {
    timezone: 'Asia/Dubai',
    offset: 4,
    text: '(+04:00) Asia/Dubai',
    abbr: 'AST',
  },
  {
    timezone: 'Asia/Muscat',
    offset: 4,
    text: '(+04:00) Asia/Muscat',
    abbr: 'AST',
  },
  {
    timezone: 'Asia/Tbilisi',
    offset: 4,
    text: '(+04:00) Asia/Tbilisi',
    abbr: 'GET',
  },
  {
    timezone: 'Asia/Yerevan',
    offset: 4,
    text: '(+04:00) Asia/Yerevan',
    abbr: 'CST',
  },
  {
    timezone: 'Etc/GMT-4',
    offset: 4,
    text: '(+04:00) Etc/GMT-4',
    abbr: 'AST',
  },
  {
    timezone: 'Europe/Astrakhan',
    offset: 4,
    text: '(+04:00) Europe/Astrakhan',
    abbr: 'SAMT',
  },
  {
    timezone: 'Europe/Samara',
    offset: 4,
    text: '(+04:00) Europe/Samara',
    abbr: 'SAMT',
  },
  {
    timezone: 'Europe/Saratov',
    offset: 4,
    text: '(+04:00) Europe/Saratov',
    abbr: '',
  },
  {
    timezone: 'Europe/Ulyanovsk',
    offset: 4,
    text: '(+04:00) Europe/Ulyanovsk',
    abbr: 'SAMT',
  },
  {
    timezone: 'Indian/Mahe',
    offset: 4,
    text: '(+04:00) Indian/Mahe',
    abbr: 'MST',
  },
  {
    timezone: 'Indian/Mauritius',
    offset: 4,
    text: '(+04:00) Indian/Mauritius',
    abbr: 'MST',
  },
  {
    timezone: 'Indian/Reunion',
    offset: 4,
    text: '(+04:00) Indian/Reunion',
    abbr: 'MST',
  },
  {
    timezone: 'Asia/Kabul',
    offset: 4.5,
    text: '(+04:30) Asia/Kabul',
    abbr: 'AST',
  },
  {
    timezone: 'Asia/Tehran',
    offset: 4.5,
    text: '(+04:30) Asia/Tehran',
    abbr: 'IDT',
  },
  { timezone: 'Iran', offset: 4.5, text: '(+04:30) Iran', abbr: '' },
  {
    timezone: 'Antarctica/Mawson',
    offset: 5,
    text: '(+05:00) Antarctica/Mawson',
    abbr: 'WAST',
  },
  {
    timezone: 'Asia/Aqtau',
    offset: 5,
    text: '(+05:00) Asia/Aqtau',
    abbr: 'WAST',
  },
  {
    timezone: 'Asia/Aqtobe',
    offset: 5,
    text: '(+05:00) Asia/Aqtobe',
    abbr: 'WAST',
  },
  {
    timezone: 'Asia/Ashgabat',
    offset: 5,
    text: '(+05:00) Asia/Ashgabat',
    abbr: 'WAST',
  },
  {
    timezone: 'Asia/Ashkhabad',
    offset: 5,
    text: '(+05:00) Asia/Ashkhabad',
    abbr: 'WAST',
  },
  {
    timezone: 'Asia/Atyrau',
    offset: 5,
    text: '(+05:00) Asia/Atyrau',
    abbr: 'WAST',
  },
  {
    timezone: 'Asia/Dushanbe',
    offset: 5,
    text: '(+05:00) Asia/Dushanbe',
    abbr: 'WAST',
  },
  {
    timezone: 'Asia/Karachi',
    offset: 5,
    text: '(+05:00) Asia/Karachi',
    abbr: 'PKT',
  },
  {
    timezone: 'Asia/Oral',
    offset: 5,
    text: '(+05:00) Asia/Oral',
    abbr: 'WAST',
  },
  {
    timezone: 'Asia/Qyzylorda',
    offset: 5,
    text: '(+05:00) Asia/Qyzylorda',
    abbr: 'CAST',
  },
  {
    timezone: 'Asia/Samarkand',
    offset: 5,
    text: '(+05:00) Asia/Samarkand',
    abbr: 'WAST',
  },
  {
    timezone: 'Asia/Tashkent',
    offset: 5,
    text: '(+05:00) Asia/Tashkent',
    abbr: 'WAST',
  },
  {
    timezone: 'Asia/Yekaterinburg',
    offset: 5,
    text: '(+05:00) Asia/Yekaterinburg',
    abbr: 'YEKT',
  },
  {
    timezone: 'Etc/GMT-5',
    offset: 5,
    text: '(+05:00) Etc/GMT-5',
    abbr: 'WAST',
  },
  {
    timezone: 'Indian/Kerguelen',
    offset: 5,
    text: '(+05:00) Indian/Kerguelen',
    abbr: 'WAST',
  },
  {
    timezone: 'Indian/Maldives',
    offset: 5,
    text: '(+05:00) Indian/Maldives',
    abbr: 'WAST',
  },
  {
    timezone: 'Asia/Calcutta',
    offset: 5.5,
    text: '(+05:30) Asia/Calcutta',
    abbr: 'IST',
  },
  {
    timezone: 'Asia/Colombo',
    offset: 5.5,
    text: '(+05:30) Asia/Colombo',
    abbr: 'SLST',
  },
  {
    timezone: 'Asia/Kolkata',
    offset: 5.5,
    text: '(+05:30) Asia/Kolkata',
    abbr: 'IST',
  },
  {
    timezone: 'Asia/Kathmandu',
    offset: 5.75,
    text: '(+05:45) Asia/Kathmandu',
    abbr: 'NST',
  },
  {
    timezone: 'Asia/Katmandu',
    offset: 5.75,
    text: '(+05:45) Asia/Katmandu',
    abbr: 'NST',
  },
  {
    timezone: 'Antarctica/Vostok',
    offset: 6,
    text: '(+06:00) Antarctica/Vostok',
    abbr: 'CAST',
  },
  {
    timezone: 'Asia/Almaty',
    offset: 6,
    text: '(+06:00) Asia/Almaty',
    abbr: 'CAST',
  },
  {
    timezone: 'Asia/Bishkek',
    offset: 6,
    text: '(+06:00) Asia/Bishkek',
    abbr: 'CAST',
  },
  {
    timezone: 'Asia/Dacca',
    offset: 6,
    text: '(+06:00) Asia/Dacca',
    abbr: 'BST',
  },
  {
    timezone: 'Asia/Dhaka',
    offset: 6,
    text: '(+06:00) Asia/Dhaka',
    abbr: 'BST',
  },
  {
    timezone: 'Asia/Kashgar',
    offset: 6,
    text: '(+06:00) Asia/Kashgar',
    abbr: 'CST',
  },
  {
    timezone: 'Asia/Omsk',
    offset: 6,
    text: '(+06:00) Asia/Omsk',
    abbr: 'NCAST',
  },
  {
    timezone: 'Asia/Qostanay',
    offset: 6,
    text: '(+06:00) Asia/Qostanay',
    abbr: 'KZT',
  },
  {
    timezone: 'Asia/Thimbu',
    offset: 6,
    text: '(+06:00) Asia/Thimbu',
    abbr: 'BTT',
  },
  {
    timezone: 'Asia/Thimphu',
    offset: 6,
    text: '(+06:00) Asia/Thimphu',
    abbr: 'BST',
  },
  {
    timezone: 'Asia/Urumqi',
    offset: 6,
    text: '(+06:00) Asia/Urumqi',
    abbr: 'CAST',
  },
  {
    timezone: 'Etc/GMT-6',
    offset: 6,
    text: '(+06:00) Etc/GMT-6',
    abbr: 'CAST',
  },
  {
    timezone: 'Indian/Chagos',
    offset: 6,
    text: '(+06:00) Indian/Chagos',
    abbr: 'CAST',
  },
  {
    timezone: 'Asia/Rangoon',
    offset: 6.5,
    text: '(+06:30) Asia/Rangoon',
    abbr: 'MST',
  },
  {
    timezone: 'Asia/Yangon',
    offset: 6.5,
    text: '(+06:30) Asia/Yangon',
    abbr: '',
  },
  {
    timezone: 'Indian/Cocos',
    offset: 6.5,
    text: '(+06:30) Indian/Cocos',
    abbr: 'MST',
  },
  {
    timezone: 'Antarctica/Davis',
    offset: 7,
    text: '(+07:00) Antarctica/Davis',
    abbr: 'SAST',
  },
  {
    timezone: 'Asia/Bangkok',
    offset: 7,
    text: '(+07:00) Asia/Bangkok',
    abbr: 'SAST',
  },
  {
    timezone: 'Asia/Barnaul',
    offset: 7,
    text: '(+07:00) Asia/Barnaul',
    abbr: 'MSK',
  },
  {
    timezone: 'Asia/Ho_Chi_Minh',
    offset: 7,
    text: '(+07:00) Asia/Ho_Chi_Minh',
    abbr: 'IDT',
  },
  {
    timezone: 'Asia/Hovd',
    offset: 7,
    text: '(+07:00) Asia/Hovd',
    abbr: 'SAST',
  },
  {
    timezone: 'Asia/Jakarta',
    offset: 7,
    text: '(+07:00) Asia/Jakarta',
    abbr: 'SAST',
  },
  {
    timezone: 'Asia/Krasnoyarsk',
    offset: 7,
    text: '(+07:00) Asia/Krasnoyarsk',
    abbr: 'NAST',
  },
  {
    timezone: 'Asia/Novokuznetsk',
    offset: 7,
    text: '(+07:00) Asia/Novokuznetsk',
    abbr: 'NCAST',
  },
  {
    timezone: 'Asia/Novosibirsk',
    offset: 7,
    text: '(+07:00) Asia/Novosibirsk',
    abbr: 'NCAST',
  },
  {
    timezone: 'Asia/Phnom_Penh',
    offset: 7,
    text: '(+07:00) Asia/Phnom_Penh',
    abbr: 'SAST',
  },
  {
    timezone: 'Asia/Pontianak',
    offset: 7,
    text: '(+07:00) Asia/Pontianak',
    abbr: 'SAST',
  },
  {
    timezone: 'Asia/Saigon',
    offset: 7,
    text: '(+07:00) Asia/Saigon',
    abbr: 'SAST',
  },
  {
    timezone: 'Asia/Tomsk',
    offset: 7,
    text: '(+07:00) Asia/Tomsk',
    abbr: 'MSK',
  },
  {
    timezone: 'Asia/Vientiane',
    offset: 7,
    text: '(+07:00) Asia/Vientiane',
    abbr: 'SAST',
  },
  {
    timezone: 'Etc/GMT-7',
    offset: 7,
    text: '(+07:00) Etc/GMT-7',
    abbr: 'SAST',
  },
  {
    timezone: 'Indian/Christmas',
    offset: 7,
    text: '(+07:00) Indian/Christmas',
    abbr: 'SAST',
  },
  {
    timezone: 'Asia/Brunei',
    offset: 8,
    text: '(+08:00) Asia/Brunei',
    abbr: 'MPST',
  },
  {
    timezone: 'Asia/Choibalsan',
    offset: 8,
    text: '(+08:00) Asia/Choibalsan',
    abbr: 'UST',
  },
  {
    timezone: 'Asia/Chongqing',
    offset: 8,
    text: '(+08:00) Asia/Chongqing',
    abbr: 'CST',
  },
  {
    timezone: 'Asia/Chungking',
    offset: 8,
    text: '(+08:00) Asia/Chungking',
    abbr: '',
  },
  {
    timezone: 'Asia/Harbin',
    offset: 8,
    text: '(+08:00) Asia/Harbin',
    abbr: 'CST',
  },
  {
    timezone: 'Asia/Hong_Kong',
    offset: 8,
    text: '(+08:00) Asia/Hong_Kong',
    abbr: 'CST',
  },
  {
    timezone: 'Asia/Irkutsk',
    offset: 8,
    text: '(+08:00) Asia/Irkutsk',
    abbr: 'NAEST',
  },
  {
    timezone: 'Asia/Kuala_Lumpur',
    offset: 8,
    text: '(+08:00) Asia/Kuala_Lumpur',
    abbr: 'MPST',
  },
  {
    timezone: 'Asia/Kuching',
    offset: 8,
    text: '(+08:00) Asia/Kuching',
    abbr: 'MPST',
  },
  {
    timezone: 'Asia/Macao',
    offset: 8,
    text: '(+08:00) Asia/Macao',
    abbr: 'CST',
  },
  {
    timezone: 'Asia/Macau',
    offset: 8,
    text: '(+08:00) Asia/Macau',
    abbr: 'CST',
  },
  {
    timezone: 'Asia/Makassar',
    offset: 8,
    text: '(+08:00) Asia/Makassar',
    abbr: 'MPST',
  },
  {
    timezone: 'Asia/Manila',
    offset: 8,
    text: '(+08:00) Asia/Manila',
    abbr: 'MPST',
  },
  {
    timezone: 'Asia/Shanghai',
    offset: 8,
    text: '(+08:00) Asia/Shanghai',
    abbr: 'CST',
  },
  {
    timezone: 'Asia/Singapore',
    offset: 8,
    text: '(+08:00) Asia/Singapore',
    abbr: 'MPST',
  },
  {
    timezone: 'Asia/Taipei',
    offset: 8,
    text: '(+08:00) Asia/Taipei',
    abbr: 'TST',
  },
  {
    timezone: 'Asia/Ujung_Pandang',
    offset: 8,
    text: '(+08:00) Asia/Ujung_Pandang',
    abbr: 'MSK',
  },
  {
    timezone: 'Asia/Ulaanbaatar',
    offset: 8,
    text: '(+08:00) Asia/Ulaanbaatar',
    abbr: 'UST',
  },
  {
    timezone: 'Asia/Ulan_Bator',
    offset: 8,
    text: '(+08:00) Asia/Ulan_Bator',
    abbr: 'UST',
  },
  {
    timezone: 'Australia/Perth',
    offset: 8,
    text: '(+08:00) Australia/Perth',
    abbr: 'WAST',
  },
  {
    timezone: 'Australia/West',
    offset: 8,
    text: '(+08:00) Australia/West',
    abbr: '',
  },
  {
    timezone: 'Etc/GMT-8',
    offset: 8,
    text: '(+08:00) Etc/GMT-8',
    abbr: 'MPST',
  },
  {
    timezone: 'Hongkong',
    offset: 8,
    text: '(+08:00) Hongkong',
    abbr: '',
  },
  { timezone: 'PRC', offset: 8, text: '(+08:00) PRC', abbr: '' },
  {
    timezone: 'Singapore',
    offset: 8,
    text: '(+08:00) Singapore',
    abbr: '',
  },
  {
    timezone: 'Australia/Eucla',
    offset: 8.75,
    text: '(+08:45) Australia/Eucla',
    abbr: '',
  },
  {
    timezone: 'Asia/Chita',
    offset: 9,
    text: '(+09:00) Asia/Chita',
    abbr: 'YST',
  },
  {
    timezone: 'Asia/Dili',
    offset: 9,
    text: '(+09:00) Asia/Dili',
    abbr: 'JST',
  },
  {
    timezone: 'Asia/Jayapura',
    offset: 9,
    text: '(+09:00) Asia/Jayapura',
    abbr: 'JST',
  },
  {
    timezone: 'Asia/Khandyga',
    offset: 9,
    text: '(+09:00) Asia/Khandyga',
    abbr: 'YST',
  },
  {
    timezone: 'Asia/Pyongyang',
    offset: 9,
    text: '(+09:00) Asia/Pyongyang',
    abbr: 'KST',
  },
  {
    timezone: 'Asia/Seoul',
    offset: 9,
    text: '(+09:00) Asia/Seoul',
    abbr: 'KST',
  },
  {
    timezone: 'Asia/Tokyo',
    offset: 9,
    text: '(+09:00) Asia/Tokyo',
    abbr: 'JST',
  },
  {
    timezone: 'Asia/Yakutsk',
    offset: 9,
    text: '(+09:00) Asia/Yakutsk',
    abbr: 'YST',
  },
  {
    timezone: 'Etc/GMT-9',
    offset: 9,
    text: '(+09:00) Etc/GMT-9',
    abbr: 'JST',
  },
  { timezone: 'Japan', offset: 9, text: '(+09:00) Japan', abbr: '' },
  {
    timezone: 'Pacific/Palau',
    offset: 9,
    text: '(+09:00) Pacific/Palau',
    abbr: 'JST',
  },
  { timezone: 'ROK', offset: 9, text: '(+09:00) ROK', abbr: '' },
  {
    timezone: 'Australia/Adelaide',
    offset: 9.5,
    text: '(+09:30) Australia/Adelaide',
    abbr: 'CAST',
  },
  {
    timezone: 'Australia/Broken_Hill',
    offset: 9.5,
    text: '(+09:30) Australia/Broken_Hill',
    abbr: 'CAST',
  },
  {
    timezone: 'Australia/Darwin',
    offset: 9.5,
    text: '(+09:30) Australia/Darwin',
    abbr: 'ACST',
  },
  {
    timezone: 'Australia/North',
    offset: 9.5,
    text: '(+09:30) Australia/North',
    abbr: '',
  },
  {
    timezone: 'Australia/South',
    offset: 9.5,
    text: '(+09:30) Australia/South',
    abbr: '',
  },
  {
    timezone: 'Australia/Yancowinna',
    offset: 9.5,
    text: '(+09:30) Australia/Yancowinna',
    abbr: '',
  },
  {
    timezone: 'Antarctica/DumontDUrville',
    offset: 10,
    text: '(+10:00) Antarctica/DumontDUrville',
    abbr: 'WPST',
  },
  {
    timezone: 'Antarctica/Macquarie',
    offset: 10,
    text: '(+10:00) Antarctica/Macquarie',
    abbr: 'CPST',
  },
  {
    timezone: 'Asia/Ust-Nera',
    offset: 10,
    text: '(+10:00) Asia/Ust-Nera',
    abbr: 'VST',
  },
  {
    timezone: 'Asia/Vladivostok',
    offset: 10,
    text: '(+10:00) Asia/Vladivostok',
    abbr: 'VST',
  },
  {
    timezone: 'Australia/ACT',
    offset: 10,
    text: '(+10:00) Australia/ACT',
    abbr: '',
  },
  {
    timezone: 'Australia/Brisbane',
    offset: 10,
    text: '(+10:00) Australia/Brisbane',
    abbr: 'EAST',
  },
  {
    timezone: 'Australia/Canberra',
    offset: 10,
    text: '(+10:00) Australia/Canberra',
    abbr: '',
  },
  {
    timezone: 'Australia/Currie',
    offset: 10,
    text: '(+10:00) Australia/Currie',
    abbr: 'TST',
  },
  {
    timezone: 'Australia/Hobart',
    offset: 10,
    text: '(+10:00) Australia/Hobart',
    abbr: 'TST',
  },
  {
    timezone: 'Australia/Lindeman',
    offset: 10,
    text: '(+10:00) Australia/Lindeman',
    abbr: 'EAST',
  },
  {
    timezone: 'Australia/Melbourne',
    offset: 10,
    text: '(+10:00) Australia/Melbourne',
    abbr: 'AEST',
  },
  {
    timezone: 'Australia/NSW',
    offset: 10,
    text: '(+10:00) Australia/NSW',
    abbr: '',
  },
  {
    timezone: 'Australia/Queensland',
    offset: 10,
    text: '(+10:00) Australia/Queensland',
    abbr: '',
  },
  {
    timezone: 'Australia/Sydney',
    offset: 10,
    text: '(+10:00) Australia/Sydney',
    abbr: 'AEST',
  },
  {
    timezone: 'Australia/Tasmania',
    offset: 10,
    text: '(+10:00) Australia/Tasmania',
    abbr: '',
  },
  {
    timezone: 'Australia/Victoria',
    offset: 10,
    text: '(+10:00) Australia/Victoria',
    abbr: '',
  },
  {
    timezone: 'Etc/GMT-10',
    offset: 10,
    text: '(+10:00) Etc/GMT-10',
    abbr: 'WPST',
  },
  {
    timezone: 'Pacific/Chuuk',
    offset: 10,
    text: '(+10:00) Pacific/Chuuk',
    abbr: '',
  },
  {
    timezone: 'Pacific/Guam',
    offset: 10,
    text: '(+10:00) Pacific/Guam',
    abbr: 'WPST',
  },
  {
    timezone: 'Pacific/Port_Moresby',
    offset: 10,
    text: '(+10:00) Pacific/Port_Moresby',
    abbr: 'WPST',
  },
  {
    timezone: 'Pacific/Saipan',
    offset: 10,
    text: '(+10:00) Pacific/Saipan',
    abbr: 'WPST',
  },
  {
    timezone: 'Pacific/Truk',
    offset: 10,
    text: '(+10:00) Pacific/Truk',
    abbr: 'WPST',
  },
  {
    timezone: 'Pacific/Yap',
    offset: 10,
    text: '(+10:00) Pacific/Yap',
    abbr: '',
  },
  {
    timezone: 'Australia/LHI',
    offset: 10.5,
    text: '(+10:30) Australia/LHI',
    abbr: '',
  },
  {
    timezone: 'Australia/Lord_Howe',
    offset: 10.5,
    text: '(+10:30) Australia/Lord_Howe',
    abbr: '',
  },
  {
    timezone: 'Antarctica/Casey',
    offset: 11,
    text: '(+11:00) Antarctica/Casey',
    abbr: 'WAST',
  },
  {
    timezone: 'Asia/Magadan',
    offset: 11,
    text: '(+11:00) Asia/Magadan',
    abbr: 'MST',
  },
  {
    timezone: 'Asia/Sakhalin',
    offset: 11,
    text: '(+11:00) Asia/Sakhalin',
    abbr: 'VST',
  },
  {
    timezone: 'Asia/Srednekolymsk',
    offset: 11,
    text: '(+11:00) Asia/Srednekolymsk',
    abbr: 'MST',
  },
  {
    timezone: 'Etc/GMT-11',
    offset: 11,
    text: '(+11:00) Etc/GMT-11',
    abbr: 'CPST',
  },
  {
    timezone: 'Pacific/Bougainville',
    offset: 11,
    text: '(+11:00) Pacific/Bougainville',
    abbr: '',
  },
  {
    timezone: 'Pacific/Efate',
    offset: 11,
    text: '(+11:00) Pacific/Efate',
    abbr: 'CPST',
  },
  {
    timezone: 'Pacific/Guadalcanal',
    offset: 11,
    text: '(+11:00) Pacific/Guadalcanal',
    abbr: 'CPST',
  },
  {
    timezone: 'Pacific/Kosrae',
    offset: 11,
    text: '(+11:00) Pacific/Kosrae',
    abbr: 'CPST',
  },
  {
    timezone: 'Pacific/Norfolk',
    offset: 11,
    text: '(+11:00) Pacific/Norfolk',
    abbr: '',
  },
  {
    timezone: 'Pacific/Noumea',
    offset: 11,
    text: '(+11:00) Pacific/Noumea',
    abbr: 'CPST',
  },
  {
    timezone: 'Pacific/Pohnpei',
    offset: 11,
    text: '(+11:00) Pacific/Pohnpei',
    abbr: '',
  },
  {
    timezone: 'Pacific/Ponape',
    offset: 11,
    text: '(+11:00) Pacific/Ponape',
    abbr: 'CPST',
  },
  {
    timezone: 'Antarctica/McMurdo',
    offset: 12,
    text: '(+12:00) Antarctica/McMurdo',
    abbr: 'NZST',
  },
  {
    timezone: 'Antarctica/South_Pole',
    offset: 12,
    text: '(+12:00) Antarctica/South_Pole',
    abbr: 'MST',
  },
  {
    timezone: 'Asia/Anadyr',
    offset: 12,
    text: '(+12:00) Asia/Anadyr',
    abbr: 'MST',
  },
  {
    timezone: 'Asia/Kamchatka',
    offset: 12,
    text: '(+12:00) Asia/Kamchatka',
    abbr: 'MST',
  },
  {
    timezone: 'Etc/GMT-12',
    offset: 12,
    text: '(+12:00) Etc/GMT-12',
    abbr: 'U',
  },
  {
    timezone: 'Kwajalein',
    offset: 12,
    text: '(+12:00) Kwajalein',
    abbr: '',
  },
  { timezone: 'NZ', offset: 12, text: '(+12:00) NZ', abbr: '' },
  {
    timezone: 'Pacific/Auckland',
    offset: 12,
    text: '(+12:00) Pacific/Auckland',
    abbr: 'NZST',
  },
  {
    timezone: 'Pacific/Fiji',
    offset: 12,
    text: '(+12:00) Pacific/Fiji',
    abbr: 'FST',
  },
  {
    timezone: 'Pacific/Funafuti',
    offset: 12,
    text: '(+12:00) Pacific/Funafuti',
    abbr: 'U',
  },
  {
    timezone: 'Pacific/Kwajalein',
    offset: 12,
    text: '(+12:00) Pacific/Kwajalein',
    abbr: 'U',
  },
  {
    timezone: 'Pacific/Majuro',
    offset: 12,
    text: '(+12:00) Pacific/Majuro',
    abbr: 'U',
  },
  {
    timezone: 'Pacific/Nauru',
    offset: 12,
    text: '(+12:00) Pacific/Nauru',
    abbr: 'U',
  },
  {
    timezone: 'Pacific/Tarawa',
    offset: 12,
    text: '(+12:00) Pacific/Tarawa',
    abbr: 'U',
  },
  {
    timezone: 'Pacific/Wake',
    offset: 12,
    text: '(+12:00) Pacific/Wake',
    abbr: 'U',
  },
  {
    timezone: 'Pacific/Wallis',
    offset: 12,
    text: '(+12:00) Pacific/Wallis',
    abbr: 'U',
  },
  {
    timezone: 'NZ-CHAT',
    offset: 12.75,
    text: '(+12:45) NZ-CHAT',
    abbr: '',
  },
  {
    timezone: 'Pacific/Chatham',
    offset: 12.75,
    text: '(+12:45) Pacific/Chatham',
    abbr: '',
  },
  {
    timezone: 'Etc/GMT-13',
    offset: 13,
    text: '(+13:00) Etc/GMT-13',
    abbr: 'TST',
  },
  {
    timezone: 'Pacific/Apia',
    offset: 13,
    text: '(+13:00) Pacific/Apia',
    abbr: 'SST',
  },
  {
    timezone: 'Pacific/Enderbury',
    offset: 13,
    text: '(+13:00) Pacific/Enderbury',
    abbr: 'TST',
  },
  {
    timezone: 'Pacific/Fakaofo',
    offset: 13,
    text: '(+13:00) Pacific/Fakaofo',
    abbr: 'TST',
  },
  {
    timezone: 'Pacific/Tongatapu',
    offset: 13,
    text: '(+13:00) Pacific/Tongatapu',
    abbr: 'TST',
  },
  {
    timezone: 'Etc/GMT-14',
    offset: 14,
    text: '(+14:00) Etc/GMT-14',
    abbr: '',
  },
  {
    timezone: 'Pacific/Kiritimati',
    offset: 14,
    text: '(+14:00) Pacific/Kiritimati',
    abbr: '',
  },
];

/**
 * Timezone information
 * @deprecated Use TimezoneV2 instead
 */
export const Timezones = [
  'Africa/Abidjan',
  'Africa/Accra',
  'Africa/Addis_Ababa',
  'Africa/Algiers',
  'Africa/Asmara',
  'Africa/Asmera',
  'Africa/Bamako',
  'Africa/Bangui',
  'Africa/Banjul',
  'Africa/Bissau',
  'Africa/Blantyre',
  'Africa/Brazzaville',
  'Africa/Bujumbura',
  'Africa/Cairo',
  'Africa/Casablanca',
  'Africa/Ceuta',
  'Africa/Conakry',
  'Africa/Dakar',
  'Africa/Dar_es_Salaam',
  'Africa/Djibouti',
  'Africa/Douala',
  'Africa/El_Aaiun',
  'Africa/Freetown',
  'Africa/Gaborone',
  'Africa/Harare',
  'Africa/Johannesburg',
  'Africa/Juba',
  'Africa/Kampala',
  'Africa/Khartoum',
  'Africa/Kigali',
  'Africa/Kinshasa',
  'Africa/Lagos',
  'Africa/Libreville',
  'Africa/Lome',
  'Africa/Luanda',
  'Africa/Lubumbashi',
  'Africa/Lusaka',
  'Africa/Malabo',
  'Africa/Maputo',
  'Africa/Maseru',
  'Africa/Mbabane',
  'Africa/Mogadishu',
  'Africa/Monrovia',
  'Africa/Nairobi',
  'Africa/Ndjamena',
  'Africa/Niamey',
  'Africa/Nouakchott',
  'Africa/Ouagadougou',
  'Africa/Porto-Novo',
  'Africa/Sao_Tome',
  'Africa/Timbuktu',
  'Africa/Tripoli',
  'Africa/Tunis',
  'Africa/Windhoek',
  'America/Adak',
  'America/Anchorage',
  'America/Anguilla',
  'America/Antigua',
  'America/Araguaina',
  'America/Argentina/Buenos_Aires',
  'America/Argentina/Catamarca',
  'America/Argentina/ComodRivadavia',
  'America/Argentina/Cordoba',
  'America/Argentina/Jujuy',
  'America/Argentina/La_Rioja',
  'America/Argentina/Mendoza',
  'America/Argentina/Rio_Gallegos',
  'America/Argentina/Salta',
  'America/Argentina/San_Juan',
  'America/Argentina/San_Luis',
  'America/Argentina/Tucuman',
  'America/Argentina/Ushuaia',
  'America/Aruba',
  'America/Asuncion',
  'America/Atikokan',
  'America/Atka',
  'America/Bahia',
  'America/Bahia_Banderas',
  'America/Barbados',
  'America/Belem',
  'America/Belize',
  'America/Blanc-Sablon',
  'America/Boa_Vista',
  'America/Bogota',
  'America/Boise',
  'America/Buenos_Aires',
  'America/Cambridge_Bay',
  'America/Campo_Grande',
  'America/Cancun',
  'America/Caracas',
  'America/Catamarca',
  'America/Cayenne',
  'America/Cayman',
  'America/Chicago',
  'America/Chihuahua',
  'America/Coral_Harbour',
  'America/Cordoba',
  'America/Costa_Rica',
  'America/Creston',
  'America/Cuiaba',
  'America/Curacao',
  'America/Danmarkshavn',
  'America/Dawson',
  'America/Dawson_Creek',
  'America/Denver',
  'America/Detroit',
  'America/Dominica',
  'America/Edmonton',
  'America/Eirunepe',
  'America/El_Salvador',
  'America/Ensenada',
  'America/Fort_Nelson',
  'America/Fort_Wayne',
  'America/Fortaleza',
  'America/Glace_Bay',
  'America/Godthab',
  'America/Goose_Bay',
  'America/Grand_Turk',
  'America/Grenada',
  'America/Guadeloupe',
  'America/Guatemala',
  'America/Guayaquil',
  'America/Guyana',
  'America/Halifax',
  'America/Havana',
  'America/Hermosillo',
  'America/Indiana/Indianapolis',
  'America/Indiana/Knox',
  'America/Indiana/Marengo',
  'America/Indiana/Petersburg',
  'America/Indiana/Tell_City',
  'America/Indiana/Vevay',
  'America/Indiana/Vincennes',
  'America/Indiana/Winamac',
  'America/Indianapolis',
  'America/Inuvik',
  'America/Iqaluit',
  'America/Jamaica',
  'America/Jujuy',
  'America/Juneau',
  'America/Kentucky/Louisville',
  'America/Kentucky/Monticello',
  'America/Knox_IN',
  'America/Kralendijk',
  'America/La_Paz',
  'America/Lima',
  'America/Los_Angeles',
  'America/Louisville',
  'America/Lower_Princes',
  'America/Maceio',
  'America/Managua',
  'America/Manaus',
  'America/Marigot',
  'America/Martinique',
  'America/Matamoros',
  'America/Mazatlan',
  'America/Mendoza',
  'America/Menominee',
  'America/Merida',
  'America/Metlakatla',
  'America/Mexico_City',
  'America/Miquelon',
  'America/Moncton',
  'America/Monterrey',
  'America/Montevideo',
  'America/Montreal',
  'America/Montserrat',
  'America/Nassau',
  'America/New_York',
  'America/Nipigon',
  'America/Nome',
  'America/Noronha',
  'America/North_Dakota/Beulah',
  'America/North_Dakota/Center',
  'America/North_Dakota/New_Salem',
  'America/Ojinaga',
  'America/Panama',
  'America/Pangnirtung',
  'America/Paramaribo',
  'America/Phoenix',
  'America/Port-au-Prince',
  'America/Port_of_Spain',
  'America/Porto_Acre',
  'America/Porto_Velho',
  'America/Puerto_Rico',
  'America/Punta_Arenas',
  'America/Rainy_River',
  'America/Rankin_Inlet',
  'America/Recife',
  'America/Regina',
  'America/Resolute',
  'America/Rio_Branco',
  'America/Rosario',
  'America/Santa_Isabel',
  'America/Santarem',
  'America/Santiago',
  'America/Santo_Domingo',
  'America/Sao_Paulo',
  'America/Scoresbysund',
  'America/Shiprock',
  'America/Sitka',
  'America/St_Barthelemy',
  'America/St_Johns',
  'America/St_Kitts',
  'America/St_Lucia',
  'America/St_Thomas',
  'America/St_Vincent',
  'America/Swift_Current',
  'America/Tegucigalpa',
  'America/Thule',
  'America/Thunder_Bay',
  'America/Tijuana',
  'America/Toronto',
  'America/Tortola',
  'America/Vancouver',
  'America/Virgin',
  'America/Whitehorse',
  'America/Winnipeg',
  'America/Yakutat',
  'America/Yellowknife',
  'Antarctica/Casey',
  'Antarctica/Davis',
  'Antarctica/DumontDUrville',
  'Antarctica/Macquarie',
  'Antarctica/Mawson',
  'Antarctica/McMurdo',
  'Antarctica/Palmer',
  'Antarctica/Rothera',
  'Antarctica/South_Pole',
  'Antarctica/Syowa',
  'Antarctica/Troll',
  'Antarctica/Vostok',
  'Arctic/Longyearbyen',
  'Asia/Aden',
  'Asia/Almaty',
  'Asia/Amman',
  'Asia/Anadyr',
  'Asia/Aqtau',
  'Asia/Aqtobe',
  'Asia/Ashgabat',
  'Asia/Ashkhabad',
  'Asia/Atyrau',
  'Asia/Baghdad',
  'Asia/Bahrain',
  'Asia/Baku',
  'Asia/Bangkok',
  'Asia/Barnaul',
  'Asia/Beirut',
  'Asia/Bishkek',
  'Asia/Brunei',
  'Asia/Calcutta',
  'Asia/Chita',
  'Asia/Choibalsan',
  'Asia/Chongqing',
  'Asia/Chungking',
  'Asia/Colombo',
  'Asia/Dacca',
  'Asia/Damascus',
  'Asia/Dhaka',
  'Asia/Dili',
  'Asia/Dubai',
  'Asia/Dushanbe',
  'Asia/Famagusta',
  'Asia/Gaza',
  'Asia/Harbin',
  'Asia/Hebron',
  'Asia/Ho_Chi_Minh',
  'Asia/Hong_Kong',
  'Asia/Hovd',
  'Asia/Irkutsk',
  'Asia/Istanbul',
  'Asia/Jakarta',
  'Asia/Jayapura',
  'Asia/Jerusalem',
  'Asia/Kabul',
  'Asia/Kamchatka',
  'Asia/Karachi',
  'Asia/Kashgar',
  'Asia/Kathmandu',
  'Asia/Katmandu',
  'Asia/Khandyga',
  'Asia/Kolkata',
  'Asia/Krasnoyarsk',
  'Asia/Kuala_Lumpur',
  'Asia/Kuching',
  'Asia/Kuwait',
  'Asia/Macao',
  'Asia/Macau',
  'Asia/Magadan',
  'Asia/Makassar',
  'Asia/Manila',
  'Asia/Muscat',
  'Asia/Nicosia',
  'Asia/Novokuznetsk',
  'Asia/Novosibirsk',
  'Asia/Omsk',
  'Asia/Oral',
  'Asia/Phnom_Penh',
  'Asia/Pontianak',
  'Asia/Pyongyang',
  'Asia/Qatar',
  'Asia/Qostanay',
  'Asia/Qyzylorda',
  'Asia/Rangoon',
  'Asia/Riyadh',
  'Asia/Saigon',
  'Asia/Sakhalin',
  'Asia/Samarkand',
  'Asia/Seoul',
  'Asia/Shanghai',
  'Asia/Singapore',
  'Asia/Srednekolymsk',
  'Asia/Taipei',
  'Asia/Tashkent',
  'Asia/Tbilisi',
  'Asia/Tehran',
  'Asia/Tel_Aviv',
  'Asia/Thimbu',
  'Asia/Thimphu',
  'Asia/Tokyo',
  'Asia/Tomsk',
  'Asia/Ujung_Pandang',
  'Asia/Ulaanbaatar',
  'Asia/Ulan_Bator',
  'Asia/Urumqi',
  'Asia/Ust-Nera',
  'Asia/Vientiane',
  'Asia/Vladivostok',
  'Asia/Yakutsk',
  'Asia/Yangon',
  'Asia/Yekaterinburg',
  'Asia/Yerevan',
  'Atlantic/Azores',
  'Atlantic/Bermuda',
  'Atlantic/Canary',
  'Atlantic/Cape_Verde',
  'Atlantic/Faeroe',
  'Atlantic/Faroe',
  'Atlantic/Jan_Mayen',
  'Atlantic/Madeira',
  'Atlantic/Reykjavik',
  'Atlantic/South_Georgia',
  'Atlantic/St_Helena',
  'Atlantic/Stanley',
  'Australia/ACT',
  'Australia/Adelaide',
  'Australia/Brisbane',
  'Australia/Broken_Hill',
  'Australia/Canberra',
  'Australia/Currie',
  'Australia/Darwin',
  'Australia/Eucla',
  'Australia/Hobart',
  'Australia/LHI',
  'Australia/Lindeman',
  'Australia/Lord_Howe',
  'Australia/Melbourne',
  'Australia/NSW',
  'Australia/North',
  'Australia/Perth',
  'Australia/Queensland',
  'Australia/South',
  'Australia/Sydney',
  'Australia/Tasmania',
  'Australia/Victoria',
  'Australia/West',
  'Australia/Yancowinna',
  'Brazil/Acre',
  'Brazil/DeNoronha',
  'Brazil/East',
  'Brazil/West',
  'CET',
  'CST6CDT',
  'Canada/Atlantic',
  'Canada/Central',
  'Canada/Eastern',
  'Canada/Mountain',
  'Canada/Newfoundland',
  'Canada/Pacific',
  'Canada/Saskatchewan',
  'Canada/Yukon',
  'Chile/Continental',
  'Chile/EasterIsland',
  'Cuba',
  'EET',
  'EST5EDT',
  'Egypt',
  'Eire',
  'Etc/GMT',
  'Etc/GMT+0',
  'Etc/GMT+1',
  'Etc/GMT+10',
  'Etc/GMT+11',
  'Etc/GMT+12',
  'Etc/GMT+2',
  'Etc/GMT+3',
  'Etc/GMT+4',
  'Etc/GMT+5',
  'Etc/GMT+6',
  'Etc/GMT+7',
  'Etc/GMT+8',
  'Etc/GMT+9',
  'Etc/GMT-0',
  'Etc/GMT-1',
  'Etc/GMT-10',
  'Etc/GMT-11',
  'Etc/GMT-12',
  'Etc/GMT-13',
  'Etc/GMT-14',
  'Etc/GMT-2',
  'Etc/GMT-3',
  'Etc/GMT-4',
  'Etc/GMT-5',
  'Etc/GMT-6',
  'Etc/GMT-7',
  'Etc/GMT-8',
  'Etc/GMT-9',
  'Etc/GMT0',
  'Etc/Greenwich',
  'Etc/UCT',
  'Etc/UTC',
  'Etc/Universal',
  'Etc/Zulu',
  'Europe/Amsterdam',
  'Europe/Andorra',
  'Europe/Astrakhan',
  'Europe/Athens',
  'Europe/Belfast',
  'Europe/Belgrade',
  'Europe/Berlin',
  'Europe/Bratislava',
  'Europe/Brussels',
  'Europe/Bucharest',
  'Europe/Budapest',
  'Europe/Busingen',
  'Europe/Chisinau',
  'Europe/Copenhagen',
  'Europe/Dublin',
  'Europe/Gibraltar',
  'Europe/Guernsey',
  'Europe/Helsinki',
  'Europe/Isle_of_Man',
  'Europe/Istanbul',
  'Europe/Jersey',
  'Europe/Kaliningrad',
  'Europe/Kiev',
  'Europe/Kirov',
  'Europe/Lisbon',
  'Europe/Ljubljana',
  'Europe/London',
  'Europe/Luxembourg',
  'Europe/Madrid',
  'Europe/Malta',
  'Europe/Mariehamn',
  'Europe/Minsk',
  'Europe/Monaco',
  'Europe/Moscow',
  'Europe/Nicosia',
  'Europe/Oslo',
  'Europe/Paris',
  'Europe/Podgorica',
  'Europe/Prague',
  'Europe/Riga',
  'Europe/Rome',
  'Europe/Samara',
  'Europe/San_Marino',
  'Europe/Sarajevo',
  'Europe/Saratov',
  'Europe/Simferopol',
  'Europe/Skopje',
  'Europe/Sofia',
  'Europe/Stockholm',
  'Europe/Tallinn',
  'Europe/Tirane',
  'Europe/Tiraspol',
  'Europe/Ulyanovsk',
  'Europe/Uzhgorod',
  'Europe/Vaduz',
  'Europe/Vatican',
  'Europe/Vienna',
  'Europe/Vilnius',
  'Europe/Volgograd',
  'Europe/Warsaw',
  'Europe/Zagreb',
  'Europe/Zaporozhye',
  'Europe/Zurich',
  'GB',
  'GB-Eire',
  'GMT',
  'GMT0',
  'Greenwich',
  'Hongkong',
  'Iceland',
  'Indian/Antananarivo',
  'Indian/Chagos',
  'Indian/Christmas',
  'Indian/Cocos',
  'Indian/Comoro',
  'Indian/Kerguelen',
  'Indian/Mahe',
  'Indian/Maldives',
  'Indian/Mauritius',
  'Indian/Mayotte',
  'Indian/Reunion',
  'Iran',
  'Israel',
  'Jamaica',
  'Japan',
  'Kwajalein',
  'Libya',
  'MET',
  'MST7MDT',
  'Mexico/BajaNorte',
  'Mexico/BajaSur',
  'Mexico/General',
  'NZ',
  'NZ-CHAT',
  'Navajo',
  'PRC',
  'PST8PDT',
  'Pacific/Apia',
  'Pacific/Auckland',
  'Pacific/Bougainville',
  'Pacific/Chatham',
  'Pacific/Chuuk',
  'Pacific/Easter',
  'Pacific/Efate',
  'Pacific/Enderbury',
  'Pacific/Fakaofo',
  'Pacific/Fiji',
  'Pacific/Funafuti',
  'Pacific/Galapagos',
  'Pacific/Gambier',
  'Pacific/Guadalcanal',
  'Pacific/Guam',
  'Pacific/Honolulu',
  'Pacific/Johnston',
  'Pacific/Kiritimati',
  'Pacific/Kosrae',
  'Pacific/Kwajalein',
  'Pacific/Majuro',
  'Pacific/Marquesas',
  'Pacific/Midway',
  'Pacific/Nauru',
  'Pacific/Niue',
  'Pacific/Norfolk',
  'Pacific/Noumea',
  'Pacific/Pago_Pago',
  'Pacific/Palau',
  'Pacific/Pitcairn',
  'Pacific/Pohnpei',
  'Pacific/Ponape',
  'Pacific/Port_Moresby',
  'Pacific/Rarotonga',
  'Pacific/Saipan',
  'Pacific/Samoa',
  'Pacific/Tahiti',
  'Pacific/Tarawa',
  'Pacific/Tongatapu',
  'Pacific/Truk',
  'Pacific/Wake',
  'Pacific/Wallis',
  'Pacific/Yap',
  'Poland',
  'Portugal',
  'ROK',
  'Singapore',
  'SystemV/AST4',
  'SystemV/AST4ADT',
  'SystemV/CST6',
  'SystemV/CST6CDT',
  'SystemV/EST5',
  'SystemV/EST5EDT',
  'SystemV/HST10',
  'SystemV/MST7',
  'SystemV/MST7MDT',
  'SystemV/PST8',
  'SystemV/PST8PDT',
  'SystemV/YST9',
  'SystemV/YST9YDT',
  'Turkey',
  'UCT',
  'US/Alaska',
  'US/Aleutian',
  'US/Arizona',
  'US/Central',
  'US/East-Indiana',
  'US/Eastern',
  'US/Hawaii',
  'US/Indiana-Starke',
  'US/Michigan',
  'US/Mountain',
  'US/Pacific',
  'US/Pacific-New',
  'US/Samoa',
  'UTC',
  'Universal',
  'W-SU',
  'WET',
  'Zulu',
];

export const fullTimezones = [
  {
    value: 'Dateline Standard Time',
    abbr: 'DST',
    offset: -12,
    isdst: false,
    text: '(UTC-12:00) International Date Line West',
    utc: ['Etc/GMT+12'],
  },
  {
    value: 'UTC-11',
    abbr: 'U',
    offset: -11,
    isdst: false,
    text: '(UTC-11:00) Coordinated Universal Time-11',
    utc: ['Etc/GMT+11', 'Pacific/Midway', 'Pacific/Niue', 'Pacific/Pago_Pago'],
  },
  {
    value: 'Hawaiian Standard Time',
    abbr: 'HST',
    offset: -10,
    isdst: false,
    text: '(UTC-10:00) Hawaii',
    utc: [
      'Etc/GMT+10',
      'Pacific/Honolulu',
      'Pacific/Johnston',
      'Pacific/Rarotonga',
      'Pacific/Tahiti',
      'America/Adak',
      'America/Atka',
    ],
  },
  {
    value: 'Alaskan Standard Time',
    abbr: 'AKDT',
    offset: -8,
    isdst: true,
    text: '(UTC-09:00) Alaska',
    utc: [
      'America/Anchorage',
      'America/Juneau',
      'America/Nome',
      'America/Sitka',
      'America/Yakutat',
      'America/Metlakatla',
    ],
  },
  {
    value: 'Pacific Standard Time (Mexico)',
    abbr: 'PDT',
    offset: -7,
    isdst: true,
    text: '(UTC-08:00) Baja California',
    utc: ['America/Santa_Isabel'],
  },
  {
    value: 'Pacific Daylight Time',
    abbr: 'PDT',
    offset: -7,
    isdst: true,
    text: '(UTC-07:00) Pacific Daylight Time (US & Canada)',
    utc: [
      'America/Los_Angeles',
      'America/Tijuana',
      'America/Vancouver',
      'America/Ensenada',
    ],
  },
  {
    value: 'Pacific Standard Time',
    abbr: 'PST',
    offset: -8,
    isdst: false,
    text: '(UTC-08:00) Pacific Standard Time (US & Canada)',
    utc: [
      'America/Los_Angeles',
      'America/Tijuana',
      'America/Ensenada',
      'America/Vancouver',
      'PST8PDT',
    ],
  },
  {
    value: 'US Mountain Standard Time',
    abbr: 'UMST',
    offset: -7,
    isdst: false,
    text: '(UTC-07:00) Arizona',
    utc: [
      'America/Creston',
      'America/Dawson',
      'America/Dawson_Creek',
      'America/Hermosillo',
      'America/Phoenix',
      'America/Whitehorse',
      'Etc/GMT+7',
      'America/Fort_Nelson',
    ],
  },
  {
    value: 'Mountain Standard Time (Mexico)',
    abbr: 'MDT',
    offset: -6,
    isdst: true,
    text: '(UTC-07:00) Chihuahua, La Paz, Mazatlan',
    utc: ['America/Chihuahua', 'America/Mazatlan'],
  },
  {
    value: 'Mountain Standard Time',
    abbr: 'MDT',
    offset: -6,
    isdst: true,
    text: '(UTC-07:00) Mountain Time (US & Canada)',
    utc: [
      'America/Boise',
      'America/Cambridge_Bay',
      'America/Denver',
      'America/Edmonton',
      'America/Inuvik',
      'America/Ojinaga',
      'America/Yellowknife',
      'America/Shiprock',
      'America/Virgin',
      'MST7MDT',
    ],
  },
  {
    value: 'Central America Standard Time',
    abbr: 'CAST',
    offset: -6,
    isdst: false,
    text: '(UTC-06:00) Central America',
    utc: [
      'America/Belize',
      'America/Costa_Rica',
      'America/El_Salvador',
      'America/Guatemala',
      'America/Managua',
      'America/Tegucigalpa',
      'Etc/GMT+6',
      'Pacific/Galapagos',
    ],
  },
  {
    value: 'Central Standard Time',
    abbr: 'CDT',
    offset: -5,
    isdst: true,
    text: '(UTC-06:00) Central Time (US & Canada)',
    utc: [
      'America/Chicago',
      'America/Indiana/Knox',
      'America/Knox_IN',
      'America/Indiana/Tell_City',
      'America/Matamoros',
      'America/Menominee',
      'America/North_Dakota/Beulah',
      'America/North_Dakota/Center',
      'America/North_Dakota/New_Salem',
      'America/Rainy_River',
      'America/Rankin_Inlet',
      'America/Resolute',
      'US/Central',
      'America/Winnipeg',
      'CST6CDT',
    ],
  },
  {
    value: 'Central Standard Time (Mexico)',
    abbr: 'CDT',
    offset: -5,
    isdst: true,
    text: '(UTC-06:00) Guadalajara, Mexico City, Monterrey',
    utc: [
      'America/Bahia_Banderas',
      'America/Cancun',
      'America/Merida',
      'America/Mexico_City',
      'America/Monterrey',
    ],
  },
  {
    value: 'Canada Central Standard Time',
    abbr: 'CCST',
    offset: -6,
    isdst: false,
    text: '(UTC-06:00) Saskatchewan',
    utc: ['America/Regina', 'America/Swift_Current'],
  },
  {
    value: 'SA Pacific Standard Time',
    abbr: 'SPST',
    offset: -5,
    isdst: false,
    text: '(UTC-05:00) Bogota, Lima, Quito',
    utc: [
      'America/Bogota',
      'America/Cayman',
      'America/Coral_Harbour',
      'America/Eirunepe',
      'America/Guayaquil',
      'America/Jamaica',
      'America/Lima',
      'America/Panama',
      'America/Rio_Branco',
      'Etc/GMT+5',
    ],
  },
  {
    value: 'Acre Time',
    abbr: 'ACT',
    offset: -5,
    isdst: false,
    text: '(UTC-05:00) Brazil Porto Acre',
    utc: ['America/Porto_Acre'],
  },
  {
    value: 'Eastern Standard Time',
    abbr: 'EST',
    offset: -5,
    isdst: false,
    text: '(UTC-05:00) Eastern Time (US & Canada)',
    utc: [
      'America/Detroit',
      'America/Havana',
      'America/Indiana/Petersburg',
      'America/Indiana/Vincennes',
      'America/Indiana/Winamac',
      'America/Iqaluit',
      'America/Kentucky/Monticello',
      'America/Louisville',
      'America/Montreal',
      'America/Nassau',
      'America/New_York',
      'America/Nipigon',
      'America/Pangnirtung',
      'America/Port-au-Prince',
      'America/Thunder_Bay',
      'America/Toronto',
      'America/Atikokan',
    ],
  },
  {
    value: 'Eastern Daylight Time',
    abbr: 'EDT',
    offset: -4,
    isdst: true,
    text: '(UTC-04:00) Eastern Daylight Time (US & Canada)',
    utc: [
      'America/Detroit',
      'America/Havana',
      'America/Indiana/Petersburg',
      'America/Indiana/Vincennes',
      'America/Indiana/Winamac',
      'America/Iqaluit',
      'America/Kentucky/Monticello',
      'America/Louisville',
      'America/Montreal',
      'America/Nassau',
      'America/New_York',
      'America/Nipigon',
      'America/Pangnirtung',
      'America/Port-au-Prince',
      'America/Thunder_Bay',
      'America/Toronto',
      'America/Indiana/Indianapolis',
      'America/Kentucky/Louisville',
    ],
  },
  {
    value: 'US Eastern Standard Time',
    abbr: 'UEDT',
    offset: -5,
    isdst: false,
    text: '(UTC-05:00) Indiana (East)',
    utc: [
      'America/Indiana/Marengo',
      'America/Indiana/Vevay',
      'America/Indianapolis',
    ],
  },
  {
    value: 'Venezuela Standard Time',
    abbr: 'VST',
    offset: -4.5,
    isdst: false,
    text: '(UTC-04:30) Caracas',
    utc: ['America/Caracas'],
  },
  {
    value: 'Paraguay Standard Time',
    abbr: 'PYT',
    offset: -4,
    isdst: false,
    text: '(UTC-04:00) Asuncion',
    utc: ['America/Asuncion'],
  },
  {
    value: 'Atlantic Standard Time',
    abbr: 'ADT',
    offset: -3,
    isdst: true,
    text: '(UTC-04:00) Atlantic Time (Canada)',
    utc: [
      'America/Glace_Bay',
      'America/Goose_Bay',
      'America/Halifax',
      'America/Moncton',
      'America/Thule',
      'Atlantic/Bermuda',
    ],
  },
  {
    value: 'Central Brazilian Standard Time',
    abbr: 'CBST',
    offset: -4,
    isdst: false,
    text: '(UTC-04:00) Cuiaba',
    utc: ['America/Campo_Grande', 'America/Cuiaba'],
  },
  {
    value: 'SA Western Standard Time',
    abbr: 'SWST',
    offset: -4,
    isdst: false,
    text: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan',
    utc: [
      'America/Anguilla',
      'America/Antigua',
      'America/Aruba',
      'America/Barbados',
      'America/Blanc-Sablon',
      'America/Boa_Vista',
      'America/Curacao',
      'America/Dominica',
      'America/Grand_Turk',
      'America/Grenada',
      'America/Guadeloupe',
      'America/Guyana',
      'America/Kralendijk',
      'America/La_Paz',
      'America/Lower_Princes',
      'America/Manaus',
      'America/Marigot',
      'America/Martinique',
      'America/Montserrat',
      'America/Port_of_Spain',
      'America/Porto_Velho',
      'America/Puerto_Rico',
      'America/Santo_Domingo',
      'America/St_Barthelemy',
      'America/St_Kitts',
      'America/St_Lucia',
      'America/St_Thomas',
      'America/St_Vincent',
      'America/Tortola',
      'Etc/GMT+4',
    ],
  },
  {
    value: 'Pacific SA Standard Time',
    abbr: 'PSST',
    offset: -4,
    isdst: false,
    text: '(UTC-04:00) Santiago',
    utc: ['America/Santiago', 'Antarctica/Palmer'],
  },
  {
    value: 'Newfoundland Standard Time',
    abbr: 'NDT',
    offset: -2.5,
    isdst: true,
    text: '(UTC-03:30) Newfoundland',
    utc: ['America/St_Johns'],
  },
  {
    value: 'E. South America Standard Time',
    abbr: 'ESAST',
    offset: -3,
    isdst: false,
    text: '(UTC-03:00) Brasilia',
    utc: ['America/Sao_Paulo'],
  },
  {
    value: 'Argentina Standard Time',
    abbr: 'AST',
    offset: -3,
    isdst: false,
    text: '(UTC-03:00) Argentina Standard Time',
    utc: [
      'America/Argentina/La_Rioja',
      'America/Argentina/Rio_Gallegos',
      'America/Argentina/Salta',
      'America/Argentina/San_Juan',
      'America/Argentina/San_Luis',
      'America/Argentina/Tucuman',
      'America/Argentina/Ushuaia',
      'America/Argentina/Buenos_Aires',
      'America/Buenos_Aires',
      'America/Catamarca',
      'America/Argentina/Catamarca',
      'America/Argentina/ComodRivadavia',
      'America/Cordoba',
      'America/Argentina/Cordoba',
      'America/Jujuy',
      'America/Mendoza',
      'America/Argentina/Mendoza',
      'America/Rosario',
    ],
  },
  {
    value: 'Chilean Summer Time',
    abbr: 'CLST',
    offset: -3,
    isdst: false,
    text: '(UTC-03:00) Buenos Aires',
    utc: ['America/Punta_Arenas'],
  },
  {
    value: 'SA Eastern Standard Time',
    abbr: 'SEST',
    offset: -3,
    isdst: false,
    text: '(UTC-03:00) Cayenne, Fortaleza',
    utc: [
      'America/Araguaina',
      'America/Belem',
      'America/Cayenne',
      'America/Fortaleza',
      'America/Maceio',
      'America/Paramaribo',
      'America/Recife',
      'America/Santarem',
      'Antarctica/Rothera',
      'Atlantic/Stanley',
      'Etc/GMT+3',
    ],
  },
  {
    value: 'Greenland Standard Time',
    abbr: 'GDT',
    offset: -3,
    isdst: true,
    text: '(UTC-03:00) Greenland',
    utc: ['America/Godthab'],
  },
  {
    value: 'Montevideo Standard Time',
    abbr: 'MST',
    offset: -3,
    isdst: false,
    text: '(UTC-03:00) Montevideo',
    utc: ['America/Montevideo'],
  },
  {
    value: 'Bahia Standard Time',
    abbr: 'BST',
    offset: -3,
    isdst: false,
    text: '(UTC-03:00) Salvador',
    utc: ['America/Bahia'],
  },
  {
    value: 'UTC-02',
    abbr: 'U',
    offset: -2,
    isdst: false,
    text: '(UTC-02:00) Coordinated Universal Time-02',
    utc: [
      'America/Noronha',
      'Atlantic/South_Georgia',
      'Etc/GMT+2',
      'America/Miquelon',
    ],
  },
  {
    value: 'Mid-Atlantic Standard Time',
    abbr: 'MDT',
    offset: -1,
    isdst: true,
    text: '(UTC-02:00) Mid-Atlantic - Old',
    utc: [],
  },
  {
    value: 'Azores Standard Time',
    abbr: 'ADT',
    offset: 0,
    isdst: true,
    text: '(UTC-01:00) Azores',
    utc: ['America/Scoresbysund', 'Atlantic/Azores'],
  },
  {
    value: 'Cape Verde Standard Time',
    abbr: 'CVST',
    offset: -1,
    isdst: false,
    text: '(UTC-01:00) Cape Verde Is.',
    utc: ['Atlantic/Cape_Verde', 'Etc/GMT+1'],
  },
  {
    value: 'Morocco Standard Time',
    abbr: 'MDT',
    offset: 1,
    isdst: true,
    text: '(UTC) Casablanca',
    utc: ['Africa/Casablanca', 'Africa/El_Aaiun'],
  },
  {
    value: 'UTC',
    abbr: 'UTC',
    offset: 0,
    isdst: false,
    text: '(UTC) Coordinated Universal Time',
    utc: ['America/Danmarkshavn', 'Etc/GMT'],
  },
  {
    value: 'GMT Standard Time',
    abbr: 'GMT',
    offset: 0,
    isdst: false,
    text: '(UTC) Edinburgh, London',
    utc: [
      'Europe/Isle_of_Man',
      'Europe/Guernsey',
      'Europe/Jersey',
      'Europe/London',
    ],
  },
  {
    value: 'British Summer Time',
    abbr: 'BST',
    offset: 1,
    isdst: true,
    text: '(UTC+01:00) Edinburgh, London',
    utc: [
      'Europe/Isle_of_Man',
      'Europe/Guernsey',
      'Europe/Jersey',
      'Europe/London',
    ],
  },
  {
    value: 'GMT Standard Time',
    abbr: 'GDT',
    offset: 1,
    isdst: true,
    text: '(UTC) Dublin, Lisbon',
    utc: [
      'Atlantic/Canary',
      'Atlantic/Faeroe',
      'Atlantic/Madeira',
      'Europe/Dublin',
      'Europe/Lisbon',
    ],
  },
  {
    value: 'Greenwich Standard Time',
    abbr: 'GST',
    offset: 0,
    isdst: false,
    text: '(UTC) Monrovia, Reykjavik',
    utc: [
      'Africa/Abidjan',
      'Africa/Accra',
      'Africa/Bamako',
      'Africa/Timbuktu',
      'Africa/Banjul',
      'Africa/Bissau',
      'Africa/Conakry',
      'Africa/Dakar',
      'Africa/Freetown',
      'Africa/Lome',
      'Africa/Monrovia',
      'Africa/Nouakchott',
      'Africa/Ouagadougou',
      'Africa/Sao_Tome',
      'Atlantic/Reykjavik',
      'Atlantic/St_Helena',
    ],
  },
  {
    value: 'W. Europe Standard Time',
    abbr: 'WEDT',
    offset: 2,
    isdst: true,
    text: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    utc: [
      'Arctic/Longyearbyen',
      'Europe/Amsterdam',
      'Europe/Andorra',
      'Europe/Berlin',
      'Europe/Busingen',
      'Europe/Gibraltar',
      'Europe/Luxembourg',
      'Europe/Malta',
      'Europe/Monaco',
      'Europe/Oslo',
      'Europe/Rome',
      'Europe/San_Marino',
      'Europe/Stockholm',
      'Europe/Vaduz',
      'Europe/Vatican',
      'Europe/Vienna',
      'Europe/Zurich',
    ],
  },
  {
    value: 'Central Europe Standard Time',
    abbr: 'CEDT',
    offset: 2,
    isdst: true,
    text: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
    utc: [
      'Europe/Belgrade',
      'Europe/Bratislava',
      'Europe/Budapest',
      'Europe/Ljubljana',
      'Europe/Podgorica',
      'Europe/Prague',
      'Europe/Tirane',
    ],
  },
  {
    value: 'Romance Standard Time',
    abbr: 'RDT',
    offset: 2,
    isdst: true,
    text: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris',
    utc: [
      'Africa/Ceuta',
      'Europe/Brussels',
      'Europe/Copenhagen',
      'Europe/Madrid',
      'Europe/Paris',
    ],
  },
  {
    value: 'Central European Standard Time',
    abbr: 'CEDT',
    offset: 2,
    isdst: true,
    text: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
    utc: ['Europe/Sarajevo', 'Europe/Skopje', 'Europe/Warsaw', 'Europe/Zagreb'],
  },
  {
    value: 'W. Central Africa Standard Time',
    abbr: 'WCAST',
    offset: 1,
    isdst: false,
    text: '(UTC+01:00) West Central Africa',
    utc: [
      'Africa/Algiers',
      'Africa/Bangui',
      'Africa/Brazzaville',
      'Africa/Douala',
      'Africa/Kinshasa',
      'Africa/Lagos',
      'Africa/Libreville',
      'Africa/Luanda',
      'Africa/Malabo',
      'Africa/Ndjamena',
      'Africa/Niamey',
      'Africa/Porto-Novo',
      'Africa/Tunis',
      'Etc/GMT-1',
    ],
  },
  {
    value: 'Namibia Standard Time',
    abbr: 'NST',
    offset: 1,
    isdst: false,
    text: '(UTC+01:00) Windhoek',
    utc: ['Africa/Windhoek'],
  },
  {
    value: 'GTB Standard Time',
    abbr: 'GDT',
    offset: 3,
    isdst: true,
    text: '(UTC+02:00) Athens, Bucharest',
    utc: [
      'Asia/Nicosia',
      'Europe/Athens',
      'Europe/Bucharest',
      'Europe/Chisinau',
    ],
  },
  {
    value: 'Eastern European Summer Time',
    abbr: 'EEST',
    offset: 3,
    isdst: true,
    text: '(UTC+02:00) Eastern European Summer Time',
    utc: ['Asia/Famagusta', 'Asia/Gaza', 'Asia/Hebron'],
  },
  {
    value: 'Middle East Standard Time',
    abbr: 'MEDT',
    offset: 3,
    isdst: true,
    text: '(UTC+02:00) Beirut',
    utc: ['Asia/Beirut'],
  },
  {
    value: 'Egypt Standard Time',
    abbr: 'EST',
    offset: 2,
    isdst: false,
    text: '(UTC+02:00) Cairo',
    utc: ['Africa/Cairo'],
  },
  {
    value: 'Syria Standard Time',
    abbr: 'SDT',
    offset: 3,
    isdst: true,
    text: '(UTC+02:00) Damascus',
    utc: ['Asia/Damascus'],
  },
  {
    value: 'E. Europe Standard Time',
    abbr: 'EEDT',
    offset: 3,
    isdst: true,
    text: '(UTC+02:00) E. Europe',
    utc: [
      'Asia/Nicosia',
      'Europe/Athens',
      'Europe/Bucharest',
      'Europe/Chisinau',
      'Europe/Helsinki',
      'Europe/Kiev',
      'Europe/Mariehamn',
      'Europe/Nicosia',
      'Europe/Riga',
      'Europe/Sofia',
      'Europe/Tallinn',
      'Europe/Uzhgorod',
      'Europe/Vilnius',
      'Europe/Zaporozhye',
    ],
  },
  {
    value: 'South Africa Standard Time',
    abbr: 'SAST',
    offset: 2,
    isdst: false,
    text: '(UTC+02:00) Harare, Pretoria',
    utc: [
      'Africa/Blantyre',
      'Africa/Bujumbura',
      'Africa/Gaborone',
      'Africa/Harare',
      'Africa/Johannesburg',
      'Africa/Kigali',
      'Africa/Lubumbashi',
      'Africa/Lusaka',
      'Africa/Maputo',
      'Africa/Maseru',
      'Africa/Mbabane',
      'Etc/GMT-2',
    ],
  },
  {
    value: 'FLE Standard Time',
    abbr: 'FDT',
    offset: 3,
    isdst: true,
    text: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
    utc: [
      'Europe/Helsinki',
      'Europe/Kiev',
      'Europe/Mariehamn',
      'Europe/Riga',
      'Europe/Sofia',
      'Europe/Tallinn',
      'Europe/Uzhgorod',
      'Europe/Vilnius',
      'Europe/Zaporozhye',
    ],
  },
  {
    value: 'Turkey Standard Time',
    abbr: 'TDT',
    offset: 3,
    isdst: false,
    text: '(UTC+03:00) Istanbul',
    utc: ['Europe/Istanbul', 'Asia/Istanbul'],
  },
  {
    value: 'Israel Standard Time',
    abbr: 'JDT',
    offset: 3,
    isdst: true,
    text: '(UTC+02:00) Jerusalem',
    utc: ['Asia/Jerusalem'],
  },
  {
    value: 'Israel Daylight Time',
    abbr: 'IDT',
    offset: 3,
    isdst: true,
    text: '(UTC+03:00) Jerusalem',
    utc: ['Asia/Jerusalem', 'Asia/Tel_Aviv'],
  },
  {
    value: 'Libya Standard Time',
    abbr: 'LST',
    offset: 2,
    isdst: false,
    text: '(UTC+02:00) Tripoli',
    utc: ['Africa/Tripoli'],
  },
  {
    value: 'Jordan Standard Time',
    abbr: 'JST',
    offset: 3,
    isdst: false,
    text: '(UTC+03:00) Amman',
    utc: ['Asia/Amman'],
  },
  {
    value: 'Arabic Standard Time',
    abbr: 'AST',
    offset: 3,
    isdst: false,
    text: '(UTC+03:00) Baghdad',
    utc: ['Asia/Baghdad'],
  },
  {
    value: 'Kaliningrad Standard Time',
    abbr: 'KST',
    offset: 3,
    isdst: false,
    text: '(UTC+02:00) Kaliningrad',
    utc: ['Europe/Kaliningrad'],
  },
  {
    value: 'Arab Standard Time',
    abbr: 'AST',
    offset: 3,
    isdst: false,
    text: '(UTC+03:00) Kuwait, Riyadh',
    utc: [
      'Asia/Aden',
      'Asia/Bahrain',
      'Asia/Kuwait',
      'Asia/Qatar',
      'Asia/Riyadh',
    ],
  },
  {
    value: 'E. Africa Standard Time',
    abbr: 'EAST',
    offset: 3,
    isdst: false,
    text: '(UTC+03:00) Nairobi',
    utc: [
      'Africa/Addis_Ababa',
      'Africa/Asmera',
      'Africa/Dar_es_Salaam',
      'Africa/Djibouti',
      'Africa/Juba',
      'Africa/Kampala',
      'Africa/Khartoum',
      'Africa/Mogadishu',
      'Africa/Nairobi',
      'Antarctica/Syowa',
      'Etc/GMT-3',
      'Indian/Antananarivo',
      'Indian/Comoro',
      'Indian/Mayotte',
    ],
  },
  {
    value: 'Moscow Standard Time',
    abbr: 'MSK',
    offset: 3,
    isdst: false,
    text: '(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk',
    utc: [
      'Europe/Kirov',
      'Europe/Moscow',
      'Europe/Simferopol',
      'Europe/Volgograd',
      'Europe/Minsk',
      'Asia/Tomsk',
      'Asia/Ujung_Pandang',
    ],
  },
  {
    value: 'Samara Time',
    abbr: 'SAMT',
    offset: 4,
    isdst: false,
    text: '(UTC+04:00) Samara, Ulyanovsk, Saratov',
    utc: ['Europe/Astrakhan', 'Europe/Samara', 'Europe/Ulyanovsk'],
  },
  {
    value: 'Iran Standard Time',
    abbr: 'IDT',
    offset: 4.5,
    isdst: true,
    text: '(UTC+03:30) Tehran',
    utc: ['Asia/Tehran'],
  },
  {
    value: 'Arabian Standard Time',
    abbr: 'AST',
    offset: 4,
    isdst: false,
    text: '(UTC+04:00) Abu Dhabi, Muscat',
    utc: ['Asia/Dubai', 'Asia/Muscat', 'Etc/GMT-4'],
  },
  {
    value: 'Azerbaijan Standard Time',
    abbr: 'ADT',
    offset: 5,
    isdst: true,
    text: '(UTC+04:00) Baku',
    utc: ['Asia/Baku'],
  },
  {
    value: 'Mauritius Standard Time',
    abbr: 'MST',
    offset: 4,
    isdst: false,
    text: '(UTC+04:00) Port Louis',
    utc: ['Indian/Mahe', 'Indian/Mauritius', 'Indian/Reunion'],
  },
  {
    value: 'Georgian Standard Time',
    abbr: 'GET',
    offset: 4,
    isdst: false,
    text: '(UTC+04:00) Tbilisi',
    utc: ['Asia/Tbilisi'],
  },
  {
    value: 'Caucasus Standard Time',
    abbr: 'CST',
    offset: 4,
    isdst: false,
    text: '(UTC+04:00) Yerevan',
    utc: ['Asia/Yerevan'],
  },
  {
    value: 'Afghanistan Standard Time',
    abbr: 'AST',
    offset: 4.5,
    isdst: false,
    text: '(UTC+04:30) Kabul',
    utc: ['Asia/Kabul'],
  },
  {
    value: 'West Asia Standard Time',
    abbr: 'WAST',
    offset: 5,
    isdst: false,
    text: '(UTC+05:00) Ashgabat, Tashkent',
    utc: [
      'Antarctica/Mawson',
      'Asia/Aqtau',
      'Asia/Aqtobe',
      'Asia/Ashgabat',
      'Asia/Dushanbe',
      'Asia/Oral',
      'Asia/Samarkand',
      'Asia/Tashkent',
      'Etc/GMT-5',
      'Indian/Kerguelen',
      'Indian/Maldives',
      'Asia/Ashkhabad',
      'Asia/Atyrau',
    ],
  },
  {
    value: 'Yekaterinburg Time',
    abbr: 'YEKT',
    offset: 5,
    isdst: false,
    text: '(UTC+05:00) Yekaterinburg',
    utc: ['Asia/Yekaterinburg'],
  },
  {
    value: 'Pakistan Standard Time',
    abbr: 'PKT',
    offset: 5,
    isdst: false,
    text: '(UTC+05:00) Islamabad, Karachi',
    utc: ['Asia/Karachi'],
  },
  {
    value: 'India Standard Time',
    abbr: 'IST',
    offset: 5.5,
    isdst: false,
    text: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
    utc: ['Asia/Kolkata', 'Asia/Calcutta'],
  },
  {
    value: 'Sri Lanka Standard Time',
    abbr: 'SLST',
    offset: 5.5,
    isdst: false,
    text: '(UTC+05:30) Sri Jayawardenepura',
    utc: ['Asia/Colombo'],
  },
  {
    value: 'Nepal Standard Time',
    abbr: 'NST',
    offset: 5.75,
    isdst: false,
    text: '(UTC+05:45) Kathmandu',
    utc: ['Asia/Kathmandu', 'Asia/Katmandu'],
  },
  {
    value: 'Central Asia Standard Time',
    abbr: 'CAST',
    offset: 6,
    isdst: false,
    text: '(UTC+06:00) Nur-Sultan (Astana)',
    utc: [
      'Antarctica/Vostok',
      'Asia/Almaty',
      'Asia/Bishkek',
      'Asia/Qyzylorda',
      'Asia/Urumqi',
      'Etc/GMT-6',
      'Indian/Chagos',
    ],
  },
  {
    value: 'Bangladesh Standard Time',
    abbr: 'BST',
    offset: 6,
    isdst: false,
    text: '(UTC+06:00) Dhaka',
    utc: ['Asia/Dhaka', 'Asia/Thimphu', 'Asia/Dacca'],
  },
  {
    value: 'Kazakhstan Standart Time',
    abbr: 'KZT',
    offset: 6,
    isdst: false,
    text: '(UTC+06:00) Kazakhstan',
    utc: ['Asia/Qostanay'],
  },
  {
    value: 'Bhutan Time',
    abbr: 'BTT',
    offset: 6,
    isdst: false,
    text: '(UTC+06:00) Bhutan',
    utc: ['Asia/Thimbu'],
  },
  {
    value: 'Myanmar Standard Time',
    abbr: 'MST',
    offset: 6.5,
    isdst: false,
    text: '(UTC+06:30) Yangon (Rangoon)',
    utc: ['Asia/Rangoon', 'Indian/Cocos'],
  },
  {
    value: 'SE Asia Standard Time',
    abbr: 'SAST',
    offset: 7,
    isdst: false,
    text: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
    utc: [
      'Antarctica/Davis',
      'Asia/Bangkok',
      'Asia/Hovd',
      'Asia/Jakarta',
      'Asia/Phnom_Penh',
      'Asia/Pontianak',
      'Asia/Saigon',
      'Asia/Vientiane',
      'Etc/GMT-7',
      'Indian/Christmas',
    ],
  },
  {
    value: 'Krasnoyarsk Standard Time',
    abbr: 'MSK',
    offset: 7,
    isdst: false,
    text: '(UTC+07:00) Krasnoyarsk Standard Time',
    utc: ['Asia/Barnaul'],
  },
  {
    value: 'N. Central Asia Standard Time',
    abbr: 'NCAST',
    offset: 7,
    isdst: false,
    text: '(UTC+07:00) Novosibirsk',
    utc: ['Asia/Novokuznetsk', 'Asia/Novosibirsk', 'Asia/Omsk'],
  },
  {
    value: 'Indochina Time',
    abbr: 'IDT',
    offset: 7,
    isdst: false,
    text: '(UTC+07:00) Indochina Time',
    utc: ['Asia/Ho_Chi_Minh'],
  },
  {
    value: 'China Standard Time',
    abbr: 'CST',
    offset: 8,
    isdst: false,
    text: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
    utc: [
      'Asia/Hong_Kong',
      'Asia/Macau',
      'Asia/Shanghai',
      'Asia/Chongqing',
      'Asia/Harbin',
      'Asia/Kashgar',
      'Asia/Macao',
    ],
  },
  {
    value: 'North Asia Standard Time',
    abbr: 'NAST',
    offset: 8,
    isdst: false,
    text: '(UTC+08:00) Krasnoyarsk',
    utc: ['Asia/Krasnoyarsk'],
  },
  {
    value: 'Singapore Standard Time',
    abbr: 'MPST',
    offset: 8,
    isdst: false,
    text: '(UTC+08:00) Kuala Lumpur, Singapore',
    utc: [
      'Asia/Brunei',
      'Asia/Kuala_Lumpur',
      'Asia/Kuching',
      'Asia/Makassar',
      'Asia/Manila',
      'Asia/Singapore',
      'Etc/GMT-8',
    ],
  },
  {
    value: 'W. Australia Standard Time',
    abbr: 'WAST',
    offset: 8,
    isdst: false,
    text: '(UTC+08:00) Perth',
    utc: ['Antarctica/Casey', 'Australia/Perth'],
  },
  {
    value: 'Taipei Standard Time',
    abbr: 'TST',
    offset: 8,
    isdst: false,
    text: '(UTC+08:00) Taipei',
    utc: ['Asia/Taipei'],
  },
  {
    value: 'Ulaanbaatar Standard Time',
    abbr: 'UST',
    offset: 8,
    isdst: false,
    text: '(UTC+08:00) Ulaanbaatar',
    utc: ['Asia/Choibalsan', 'Asia/Ulaanbaatar', 'Asia/Ulan_Bator'],
  },
  {
    value: 'North Asia East Standard Time',
    abbr: 'NAEST',
    offset: 8,
    isdst: false,
    text: '(UTC+08:00) Irkutsk',
    utc: ['Asia/Irkutsk'],
  },
  {
    value: 'Japan Standard Time',
    abbr: 'JST',
    offset: 9,
    isdst: false,
    text: '(UTC+09:00) Osaka, Sapporo, Tokyo',
    utc: [
      'Asia/Dili',
      'Asia/Jayapura',
      'Asia/Tokyo',
      'Etc/GMT-9',
      'Pacific/Palau',
    ],
  },
  {
    value: 'Korea Standard Time',
    abbr: 'KST',
    offset: 9,
    isdst: false,
    text: '(UTC+09:00) Seoul',
    utc: ['Asia/Pyongyang', 'Asia/Seoul'],
  },
  {
    value: 'Cen. Australia Standard Time',
    abbr: 'CAST',
    offset: 9.5,
    isdst: false,
    text: '(UTC+09:30) Adelaide',
    utc: ['Australia/Adelaide', 'Australia/Broken_Hill'],
  },
  {
    value: 'AUS Central Standard Time',
    abbr: 'ACST',
    offset: 9.5,
    isdst: false,
    text: '(UTC+09:30) Darwin',
    utc: ['Australia/Darwin'],
  },
  {
    value: 'E. Australia Standard Time',
    abbr: 'EAST',
    offset: 10,
    isdst: false,
    text: '(UTC+10:00) Brisbane',
    utc: ['Australia/Brisbane', 'Australia/Lindeman'],
  },
  {
    value: 'AUS Eastern Standard Time',
    abbr: 'AEST',
    offset: 10,
    isdst: false,
    text: '(UTC+10:00) Canberra, Melbourne, Sydney',
    utc: ['Australia/Melbourne', 'Australia/Sydney'],
  },
  {
    value: 'West Pacific Standard Time',
    abbr: 'WPST',
    offset: 10,
    isdst: false,
    text: '(UTC+10:00) Guam, Port Moresby',
    utc: [
      'Antarctica/DumontDUrville',
      'Etc/GMT-10',
      'Pacific/Guam',
      'Pacific/Port_Moresby',
      'Pacific/Saipan',
      'Pacific/Truk',
    ],
  },
  {
    value: 'Tasmania Standard Time',
    abbr: 'TST',
    offset: 10,
    isdst: false,
    text: '(UTC+10:00) Hobart',
    utc: ['Australia/Currie', 'Australia/Hobart'],
  },
  {
    value: 'Yakutsk Standard Time',
    abbr: 'YST',
    offset: 9,
    isdst: false,
    text: '(UTC+09:00) Yakutsk',
    utc: ['Asia/Chita', 'Asia/Khandyga', 'Asia/Yakutsk'],
  },
  {
    value: 'Central Pacific Standard Time',
    abbr: 'CPST',
    offset: 11,
    isdst: false,
    text: '(UTC+11:00) Solomon Is., New Caledonia',
    utc: [
      'Antarctica/Macquarie',
      'Etc/GMT-11',
      'Pacific/Efate',
      'Pacific/Guadalcanal',
      'Pacific/Kosrae',
      'Pacific/Noumea',
      'Pacific/Ponape',
    ],
  },
  {
    value: 'Vladivostok Standard Time',
    abbr: 'VST',
    offset: 11,
    isdst: false,
    text: '(UTC+11:00) Vladivostok',
    utc: ['Asia/Sakhalin', 'Asia/Ust-Nera', 'Asia/Vladivostok'],
  },
  {
    value: 'New Zealand Standard Time',
    abbr: 'NZST',
    offset: 12,
    isdst: false,
    text: '(UTC+12:00) Auckland, Wellington',
    utc: ['Antarctica/McMurdo', 'Pacific/Auckland'],
  },
  {
    value: 'UTC+12',
    abbr: 'U',
    offset: 12,
    isdst: false,
    text: '(UTC+12:00) Coordinated Universal Time+12',
    utc: [
      'Etc/GMT-12',
      'Pacific/Funafuti',
      'Pacific/Kwajalein',
      'Pacific/Majuro',
      'Pacific/Nauru',
      'Pacific/Tarawa',
      'Pacific/Wake',
      'Pacific/Wallis',
    ],
  },
  {
    value: 'Fiji Standard Time',
    abbr: 'FST',
    offset: 12,
    isdst: false,
    text: '(UTC+12:00) Fiji',
    utc: ['Pacific/Fiji'],
  },
  {
    value: 'Magadan Standard Time',
    abbr: 'MST',
    offset: 12,
    isdst: false,
    text: '(UTC+12:00) Magadan',
    utc: [
      'Asia/Anadyr',
      'Asia/Kamchatka',
      'Asia/Magadan',
      'Asia/Srednekolymsk',
      'Antarctica/South_Pole',
    ],
  },
  {
    value: 'Kamchatka Standard Time',
    abbr: 'KDT',
    offset: 13,
    isdst: true,
    text: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old',
    utc: ['Asia/Kamchatka'],
  },
  {
    value: 'Tonga Standard Time',
    abbr: 'TST',
    offset: 13,
    isdst: false,
    text: "(UTC+13:00) Nuku'alofa",
    utc: [
      'Etc/GMT-13',
      'Pacific/Enderbury',
      'Pacific/Fakaofo',
      'Pacific/Tongatapu',
    ],
  },
  {
    value: 'Samoa Standard Time',
    abbr: 'SST',
    offset: 13,
    isdst: false,
    text: '(UTC+13:00) Samoa',
    utc: ['Pacific/Apia'],
  },
];

export const getTimeZoneAbbr = (timezone: string): string => {
  const timezoneObj = fullTimezones.find(
    (tz) => tz.utc.indexOf(timezone) !== -1,
  );
  if (timezoneObj) {
    return timezoneObj.abbr;
  }

  return timezone;
};
